/**
 * @module 日本語文言定義
 */
import ja from 'vuetify/src/locale/ja.ts';
export const jpn = {
  ...ja,
  English: 'English',
  // 既存サービス
  既存サービス: {
    外出ALSOK警備: '外出 ALSOK 警備',
    在宅ALSOK警備: '在宅 ALSOK 警備',
    侵入: '侵入',
    非常: '非常/救急',
    火災: '火災',
    ガス: 'ガス',
    ライフリズム: 'ライフリズム',
    解除モード: '解除',
    IDカードキー操作: 'ID カード／キー操作',
    外出: '外出',
    在宅: '在宅',
    解除ボタン: '解除',
    侵入警報: '侵入警報',
    火災警報: '火災警報',
    ガス警報: 'ガス警報',
    非常警報: '非常警報',
    ライフリズム警報: 'ライフリズム警報',
    電源異常警報: '電源異常警報',
    電池切れ警報: '電池切れ警報',
  },
  // コード
  コード: {
    サービス種別: {
      ホームセキュリティオンライン監視プラン: 'ホームセキュリティ（オンラインセキュリティ）',
      ホームセキュリティ依頼かけつけプラン: 'ホームセキュリティ（セルフセキュリティ） ',
      ホームセキュリティセルフ監視プラン:
        'ホームセキュリティ（セルフセキュリティ(依頼駆けつけなし)）',
      カメラオンラインプラン: 'カメラ（オンラインセキュリティ）',
      カメラ依頼かけつけプラン: 'カメラ（セルフセキュリティ）',
      カメラセルフ監視プラン: 'カメラ（セルフセキュリティ(依頼駆けつけなし)） ',
    },
    警備情報: {
      外出ALSOK警備中: '外出 ALSOK 警備中',
      在宅ALSOK警備中: '在宅 ALSOK 警備中',
      外出セルフ警備中: '外出セルフ警備中',
      在宅セルフ警備中: '在宅セルフ警備中',
      警備解除中: '警備解除中',
      ユーザ点検中: 'ユーザ点検中',
    },
    セキュリティの更新状況: {
      正常: '正常',
      現在と同じ警備ステータス: '',
      戸締まり異常発生中: '戸締まり異常発生中',
    },
    警報センサー状態: {
      異常なし: '異常なし',
      発報中: '発報中',
    },
    見守り方法: {
      使用しない: '使用しない',
      定期連絡: '定期連絡',
      異常通知: '異常通知',
      定刻連絡: '定刻連絡',
    },
    警報ユニット状態: {
      正常: '正常',
      異常: '異常',
      停止: '停止',
    },
    性別: {
      未指定: '未指定',
      男性: '男性',
      女性: '女性',
    },
    カメラユーザ種別: {
      メインユーザ: 'メインユーザ',
      サブユーザ: 'サブユーザ',
    },
    承認区分: {
      承認: '承認',
      否認: '否認',
    },
    通知状況: {
      通知なし: '通知なし',
      警報通知: '警報通知',
      警備セット解除通知: '警備セット/解除通知',
      状態信号通知: '状態信号通知',
      ALSOKからのお知らせ: 'ALSOKからのお知らせ',
    },
    ニックネーム登録結果: {
      正常: '正常',
      登録不可: '登録不可',
    },
    ワンタイムURL状態: {
      正常: '正常',
      存在しないURL: '存在しないURL',
    },
    警報種別: {
      警報なし: '警報なし',
      侵入: '侵入',
      非常: '非常/救急',
      火災: '火災',
      ガス: 'ガス',
      ライフリズム: 'ライフリズム',
      電池: '電池',
      機器異常: '機器異常',
      設備: '設備',
    },
    OAuth認証エラーコード: {
      認証成功: '認証成功',
      認証失敗: '認証失敗',
    },
    サービス追加エラーコード: {
      登録完了: '登録完了',
      登録失敗: '登録失敗（入力情報が誤り）',
      メインユーザ登録済み: 'メインユーザ登録済み',
    },
    利用プランID: {
      オンライン監視プラン: 'オンラインセキュリティ',
      依頼かけつけプラン: 'セルフセキュリティ',
      セルフ監視プラン: 'セルフセキュリティ(依頼駆けつけなし)',
      カメラ依頼かけつけプラン: '依頼駆けつけ可能',
      カメラセルフ監視プラン: 'なし',
    },
    ユニット運用状態: {
      未開始: '未開始',
      警備中: '警備中',
      中断中: '中断中',
      解約: '解約',
      その他: 'その他（エラー）',
    },
    機種ID: {
      S_860_GS: 'S_860_GS',
      S_728_HS: 'S_728_HS',
      S_860M_GSM: 'S_860M_GSM',
      S_861_G6: 'S_861_G6',
      CU_861_G6: 'CU_861_G6',
      S_729: 'S-729',
      S_730: 'S-730',
      eCame3: 'eCame3',
      指定なし: '指定なし',
    },
    対象地区ユーザ種別: {
      メインユーザ: 'メインユーザ',
      サブユーザ: 'サブユーザ',
    },
    ユーザー種別: {
      メインユーザ: 'メインユーザ',
      サブユーザ: 'サブユーザ',
    },
    アカウント登録状態: {
      本登録: '本登録',
      仮登録: '仮登録',
    },
    ユーザーロック状態: {
      ロックあり: 'ロックあり',
      ロックなし: 'ロックなし',
    },
    運用状態: {
      未開始: '未開始',
      警備中: '警備中',
      中断中: '中断中',
      解約: '解約',
      その他エラー: 'その他（エラー）',
    },
    カメラ運用状態: {
      未開始: '未開始',
      警備中: '警備中',
      中断中: '中断中',
      解約: '解約',
      その他エラー: 'その他（エラー）',
    },
    ログイン結果: {
      ログイン成功: 'ログイン成功',
      認証が必要: '2段階認証が必要',
      ログイン失敗: 'ログイン失敗',
    },
    お知らせ通知対象ユーザー種別: {
      メインユーザー: 'メインユーザー',
      サブユーザー: 'サブユーザー',
      全ユーザー: '全ユーザー',
      指定ユーザー: '指定ユーザー',
      指定なし: '指定なし',
    },
    ユニット種別: {
      警備ユニット: '警備ユニット',
      カメラ: 'カメラ',
    },
    送信状態: {
      未送信: '未送信',
      送信済み: '送信済み',
      エラー: 'エラー',
      リトライ: 'リトライ',
    },
    同居家族続柄: {
      本人: '本人',
      夫: '夫',
      妻: '妻',
      子: '子',
      孫: '孫',
      父: '父',
      母: '母',
      兄: '兄',
      姉: '姉',
      弟: '弟',
      妹: '妹',
      祖父: '祖父',
      祖母: '祖母',
      その他: 'その他',
      未選択: '未選択',
    },
    カメラ連携結果: {
      連携完了: '連携完了',
      連携失敗: '連携失敗',
      連携途中: '連携途中',
      デバイスID誤り: 'デバイスID誤り',
    },
    ユーザ権限種別対象地区: {
      警備操作: '警備操作',
      かけつけ依頼: '依頼駆けつけ',
      通知履歴: '通知履歴',
      機器制御: '機器制御',
      ALSOKへのお問い合わせ: 'ALSOKへのお問い合わせ',
      ニックネーム設定: 'ニックネーム設定',
      IDカードキー情報設定: 'ID/カードキー情報設定',
      見守り情報配信設定: '見守り情報配信設定',
      戸締り確認警報確認: '戸締り確認/警報確認',
      在宅対象設定: '在宅対象設定',
      ユーザ管理: 'ユーザ管理',
      緊急連絡先: '緊急連絡先',
      メインユーザ: 'メインユーザ',
    },
    ユーザ権限種別カメラ: {
      カメラ映像: 'カメラ映像',
      かけつけ依頼: '依頼駆けつけ',
      通知履歴: '通知履歴',
      ALSOKへのお問い合わせ: 'ALSOKへのお問い合わせ',
      ニックネーム設定: 'ニックネーム設定',
      ユーザ管理: 'ユーザ管理',
      緊急連絡先: '緊急連絡先',
      メインユーザ: 'メインユーザ',
    },
    通知配信設定種別対象地区: {
      警備操作: '警備操作',
      侵入: '侵入',
      火災: '火災',
      火災復旧: '火災-復旧',
      ガス: 'ガス',
      ガス復旧: 'ガス-復旧',
      非常救急: '非常/救急',
      非常救急復旧: '非常/救急-復旧',
      ライフリズム: 'ライフリズム',
      ライフリズム復旧: 'ライフリズム-復旧',
      設備: '設備',
      設備復旧: '設備-復旧',
      電池切れ: '電池切れ',
      電池切れ復旧: '電池切れ-復旧',
      機器異常: '機器異常',
      機器異常復旧: '機器異常-復旧',
      お知らせ: 'お知らせ',
      通知有無: '通知有無',
    },
    通知配信設定種別カメラ: {
      動体検知ローバッテリー: '動体検知・ローバッテリー',
      通知有無: '通知有無',
    },
    検知種別: {
      動体検知ローバッテリー: '動体検知・ローバッテリー',
    },
    曜日: {
      日: '日',
      月: '月',
      火: '火',
      水: '水',
      木: '木',
      金: '金',
      土: '土',
    },
  },
  // メッセージ一覧
  メッセージ一覧: {
    FECU01ログイン画面: {
      E0001: 'ユーザーID(メールアドレス)は必ず入力してください。',
      E0004: 'パスワードは必ず入力してください。',
      E0007: 'ログインに失敗しました。\n（エラーコード：FE-CU1-E0007）',
      E0008:
        'スマートフォン・タブレットの生体認証が無効となっており利用できません。\nスマートフォン・タブレットの設定をご確認ください。\n（エラーコード：FE-CU1-E0008）',
      E0010:
        '認証に失敗しました。\nパスコード認証をご利用頂けません。\n（エラーコード：FE-CU1-E0010）',
      E0011:
        'パスコードが間違っています。\nもう1度パスコードを入力して下さい。\n（エラーコード：FE-CU1-E0011）',
      C0001:
        '利用規約/プライバシーポリシー画面はWEBブラウザで表示します。\n利用規約/プライバシーポリシー画面を表示しますか。',
      C0002:
        'パスワード初期化(ユーザーID)画面はWEBブラウザで表示します。\nパスワード初期化(ユーザーID)画面を表示しますか。',
    },
    FENV01ログイン画面: {
      E0001:
        'サーバーと通信できません。\nネットワーク設定を変更し、再度お試しください。\n（エラーコード：FE-NV1-E0001）',
    },
    FECU02トップ画面: {
      E0001:
        'ログインの有効期限が過ぎました。\n再度ログインしてください。\n（エラーコード：FE-CU2-E0001）',
      //  'ご利用中のアカウントで、別の端末もしくはブラウザからログインがありました。\n本端末を使用する場合は、再度ログインしてください。\n（エラーコード：FE-CU2-E0001）',
      E0002:
        '一定時間操作がなかったためログアウトしました。\n再度ログインしてください。\n（エラーコード：FE-CU2-E0002）',
      E0003: 'システムエラーが発生しました。\n（エラーコード：FE-CU2-E0003）',
      E0004:
        '内容が更新されました。\n画面をもう一度更新してください。\n（エラーコード：FE-CU2-E0004）',
      E0005:
        'アプリの起動に失敗しました。\nもう一度電話番号ボタンを押してください。\n（エラーコード：FE-CU2-E0005）',
      C0001: '{ボタン名}が完了しました。',
      E0006:
        'アプリの起動に失敗しました。\nもう一度電話番号ボタンを押してください。\n（エラーコード：FE-CU2-E0006）',
      E0007:
        'システムエラーが発生しました。\nALSOK営業までご連絡ください。\n（エラーコード：FE-CU2-E0007）',
      E0008:
        '通信に失敗しました。\nしばらく時間をおいて再度実行してください。\n（エラーコード：FE-CU2-E0008）',
      E0009:
        '警備ユニットとサーバー間の通信に失敗しました。\nALSOKの担当事業所までご連絡ください。\n（エラーコード：FE-CU2-E0009）',
      E0011:
        '警備ユニットがエラーを返しました。\nもう一度操作を行ってください。\n（エラーコード：FE-CU2-E0011）',
    },
    FECU03二段階認証画面: {
      E0001:
        '認証コードが正しくありません。\nもう一度認証コードを入力してください。\n（エラーコード：FE-CU3-E0001）',
      E0002: '認証コードは必ず入力してください。',
    },
    FECU04パスワード初期化画面ユーザーID入力: {
      E0001: 'ユーザーID(メールアドレス)は必ず入力してください。',
      E0004: '確認用ユーザーID(メールアドレス)は必ず入力してください。',
      E0007: 'ユーザーID(メールアドレス)と確認用ユーザーID(メールアドレス)が一致しません。',
      C0001:
        'パスワード初期化を行います。ご登録済みのユーザーID（メールアドレス)を入力してください。\n入力されたメールアドレス宛にワンタイムURLを記載したメールを送信します。ワンタイムURLへアクセスして手続きを進めてください。',
      E0008: 'ユーザーID(メールアドレス)の形式が正しくありません。',
      E0009: '確認用ユーザーID(メールアドレス)の形式が正しくありません。',
      E0010: '登録に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU4-E0010）',
    },
    FECU05パスワード初期化画面秘密の質問: {
      C0001:
        'パスワード初期化のため、本人確認を行います。ユーザー登録時に設定した秘密の質問の回答を入力してください。\nメインユーザーが秘密の質問に対する回答を忘れた場合は、 ALSOKの 担当事業所へお問い合わせください。\nサブユーザーが秘密の質問に対する回答を忘れた場合は、ユーザーを再登録する必要があります。メインユーザーに依頼してください。',
      E0001: '回答は必ず入力してください。',
      E0003: '回答が誤っています。\n（エラーコード：FE-CU5-E0003）',
      E0004:
        '秘密の質問の回答を一定回数間違えたためアカウントがロックされました。\n（エラーコード：FE-CU5-E0004）',
      E0005: '回答はひらがなで入力してください。',
    },
    FECU06パスワード初期化画面パスワード再登録: {
      C0001:
        'パスワードの再設定を行います。\nパスワードは推測されにくい値を設定してください。\nパスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上を使用し、8文字以上の文字を設定してください。',
      C0002: '入力された内容で登録します。\nよろしいでしょうか？',
      E0001: '新パスワードは必ず入力してください。',
      E0003: '確認用パスワードは必ず入力してください。',
      E0005: '新パスワードと確認用パスワードが一致しません。',
      E0006:
        '再登録処理に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU6-E0006）',
      E0008:
        '新パスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。',
      E0010:
        '確認用パスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。',
      E0011: 'パスワードは8文字以上入力してください。',
      E0012:
        '再登録処理に失敗しました。\n再度メール本文に記載されているURLより、秘密の質問を入力後、新しいパスワードの設定を行ってください。\n（エラーコード：FE-CU6-E0012）',
    },
    FECU07トップ画面: {
      C0001:
        'トップ画面では、ご契約内容に応じて以下の操作が可能です。\n・警備操作\n　警備の開始や解除を行うことができます。\n　対象地区選択ボタンより、警備操作を行う対象の地区の選択や地区ごとに在宅対象エリアの設定が可能です。\n　警備状態を変更するときは、「外出/在宅/解除」「ALSOK/セルフ」から変更したい警備状態を選択し「警備状態を変更」ボタンを押してください。\n・ホームセキュリティボタン\n　ホームセキュリティに関する各種操作ができる画面が表示されます。（複数地区をご契約の場合は、操作対象の地区を選択する画面が表示されます）\n・カメラボタン\n　カメラに関する各種操作ができる画面が表示されます。（複数のカメラをご契約の場合は、操作対象のカメラを選択する画面が表示されます）\n・サービス追加ボタン\n　アプリやWEBサイトでご利用いただくサービスを追加するための画面が表示されます。\n・健康相談等ボタン\n　健康相談などのご連絡をいただく際はこちらより連絡先をご確認ください。\n\n画面下部にはALSOKからのお知らせが表示されておりますのでご確認ください。',
      C0002:
        '{0}件中{1}件の地区の警報を解除しました。\n指定した以下地区は既に解除状態です。\n　・対象地区：{2}',
      C0003: '{0}件中{1}件の地区の警備を開始しました。\n',
      C0004:
        '{0}件中{1}件の地区の警備を開始しました。\n以下の問題から警備が開始できなかった地区があります。\n　・対象地区：{2}\n　　警備ユニットがエラーを返しました。\n　　もう一度操作を行ってください。',
      C0005:
        '以下の問題から警備が開始できなかった地区があります。\n\n・対象地区：{0}\n　戸締り状態が異常です。\n　戸締り確認を行ってください。',
      C0006:
        '{0}件中{1}件の地区の警備を開始いたしました。\n\n以下の問題から警備が開始出来なかった地区があります。\n　・対象地区：{2}\n　警備ユニットがエラーを返しました。\n　　もう一度操作を行ってください。\n　・対象地区：{3}\n　　戸締り状態が異常です。\n　　戸締り確認を行ってください。\n\n指定した以下地区は警備状態を変更できませんでした。\n一度解除状態に変更後、警備操作をするか、契約種別をご確認ください。\n\n　・対象地区：{4}',
      C0007: '警備状態を変更します。\nよろしいでしょうか。',
      C0008: '設定した内容で登録が完了しました。',
      C0011: '{0}件中{1}件の地区の警備を解除しました。\n',
      C0017:
        'サービス追加画面はWEBブラウザで表示します。\nこの際、アプリからはログアウトされます。\nサービス追加画面を表示しますか。',
      E0001:
        'システムエラーが発生しました。\nALSOK営業までご連絡ください。\n（エラーコード：FE-CU7-E0001）',
      E0002:
        '通信に失敗しました。\nしばらく時間をおいて再度実行してください。\n（エラーコード：FE-CU7-E0002）',
      E0003:
        '警備ユニットとサーバー間の通信に失敗しました。\nALSOKの担当事業所までご連絡ください。\n（エラーコード：FE-CU7-E0003）',
      E0004: '警備操作に失敗しました。',
      E0005: '警備対象地区設定の登録に失敗しました。\nもう一度操作してください。',
      E0006: '在宅対象情報の取得に失敗しました。\nもう一度操作してください。',
      E0007: '在宅対象情報の更新に失敗しました。\nもう一度操作してください。',
    },
    FECU08ホームセキュリティ画面: {
      C0001:
        'ご利用中のユーザーに登録された対象地区の一覧が表示されます。\n各対象地区に表示されているアイコンは、ユーザーがその地区で利用できる機能を示しています。\n各対象地区を押下することで詳細を確認することができます。\n\n通知履歴(24時間以内)タブには、一覧に表示された対象地区の通知が表示されます。',
      C0002: '権限がないため通知履歴を表示できません。',
    },
    FECU09対象地区詳細画面: {
      C0001:
        '対象地区の現在の情報が表示されます。ご契約内容に応じて表示される各ボタンからより詳しい情報を確認いただけます。\n\n・ユーザー警備操作ボタン\n対象地区に対して警備操作を行うことができます。また、警報や戸締り状態の確認もこちらから行います。\n・依頼駆けつけボタン\nALSOKに対象地区への依頼駆けつけ（有償）を行うことができます。\n・通知履歴ボタン\nご利用ユーザー宛に発信された通知履歴を確認することができます。\n・ALSOKへのお問い合わせボタン\nお問い合わせのための連絡先を確認することができます。\n・対象地区設定\n対象地区の設定画面を開きます。\n・機器制御ボタン\n対象地区に設置された機器の遠隔制御を行うことができます。\n\n通知履歴(24時間以内)タブには、対象地区の通知が表示されます。（通知/通知履歴の権限がない場合は表示されません）',
      E0003:
        '警備ユニットとサーバー間の通信に失敗しました。\nALSOKの担当事業所までご連絡ください。\n（エラーコード：FE-CU9-E0003）',
    },
    FECU10ユーザー警備操作画面: {
      C0001:
        '対象地区の警備操作を行うことができます。\n警備状態を変更するときは、「外出/在宅/解除」「ALSOK/セルフ」から変更したい警備状態を選択し「警備状態を変更」ボタンを押してください。\n戸締り異常の場合、警備状態の切り替えをすることができません。\nまた、現在と同じ警備状態への切り替えをすることもできません。\n\n警報確認ボタンまたは戸締り確認ボタンを押して、現在発生中の異常を確認することができます。\n在宅対象設定ボタンを押して在宅対象エリアを選択することで、在宅警備を行うエリアを変更することができます。',
      C0002: '指定した地区は既に解除状態です。',
      C0003: '警備状態を変更しました。',
      C0004:
        '戸締り状態が異常です。\n戸締り確認を行ってください。（複数地区をご契約のお客様は共用部の戸締りもご確認ください。）',
      C0005: '警備状態の変更に失敗しました。',
      C0006: '警備状態を変更します。\nよろしいでしょうか。',
      C0007: '警備状態を変更しました。',
      C0008: '設定した内容で登録が完了しました。',
      E0001:
        '警備ユニットがエラーを返しました。\nもう一度操作を行ってください。\n（エラーコード：FE-CU10-E0001）',
      E0002:
        '通信に失敗しました。\nしばらく時間をおいて再度実行してください。\n（エラーコード：FE-CU10-E0002）',
      E0005:
        '在宅対象エリアの適用に失敗しました。\nもう一度操作してください。\n（エラーコード：FE-CU10-E0005）',
      E0007:
        '警備状態を変更できませんでした。\nすでに解除されている場合があります。警備状態をご確認ください。\n（エラーコード：FE-CU10-E0007）',
      E0008:
        '戸締り状態が異常です。\n戸締り確認を行ってください。（複数地区をご契約のお客様は共用部の戸締りもご確認ください。）\n（エラーコード：FE-CU10-E0008）',
      E0009:
        '警備状態を変更できませんでした。\n一度解除状態に変更後、警備操作をするか、契約種別をご確認ください。\n（エラーコード：FE-CU10-E0009）',
    },
    FECU12警報確認画面: {
      C0001:
        '対象地区について警報の状態を確認できます。\nアイコンの色は以下の状態を表します。\n赤色：警報が発生中\n白色：正常状態\n各警報のアイコンを押すと、設置されたセンサーごとの状態を確認できます。\n侵入警報を解除するには、ユーザーによる警備操作が必要です。',
    },
    FECU13戸締り確認画面: {
      C0001:
        '対象地区のエリアごとに戸締りの状態を確認できます。\nアイコンの色は以下の状態を表します。\n赤色：戸締り異常\n白色：正常状態\n灰色：戸締り状態取得失敗\n各エリアを押すと、設置された開閉センサーごとの状態を確認できます。',
    },
    FECU14警報確認画面センサー: {
      C0001:
        '対象地区の警報装置の状態が表示されます。センサーが異常を検知した場合、各センサーの状況を確認いただけます。\nセルフセキュリティをご契約のお客様は、こちらの画面から状況を確認し、必要に応じてALSOKへ依頼駆けつけを行ってください。（依頼駆けつけ画面より、連絡先を確認できます）',
    },
    FECU15戸締り確認画面エリア: {
      C0001:
        '対象のエリアに設置された防犯センサーの状態を確認できます。\n戸締り異常は以下の操作により正常になります。\n・開閉センサーが設置された扉を閉める\n・空間センサーの検知エリアから離れる',
    },
    FECU16かけつけ依頼画面: {
      C0001:
        '電話にて依頼駆けつけ（有償）を行うことができます。\n画面に表示されている注意事項をご確認の上お電話ください。\nスマートフォンをご利用の場合は電話番号を押すと電話アプリが起動します。\nPCをご利用の場合は、画面に表示された電話番号宛てに電話をおかけください。',
    },
    FECU17通知履歴画面: {
      C0001:
        '31日前までの通知を確認できます。\nホームセキュリティやカメラの通知については、対象地区やカメラ、警報の種類などで表示する通知を絞り込むことができます。',
    },
    FECU18ALSOKへのお問い合わせ画面: {
      C0001:
        'ALSOKへのお問い合わせの電話番号となります。\n画面に表示されている注意事項をご確認の上お電話ください。\nスマートフォンをご利用の場合は電話番号を押すと電話アプリが起動します。\nPCをご利用の場合は、画面に表示された電話番号宛てに電話をおかけください。',
    },
    FECU19対象地区設定画面: {
      C0001: '対象の地区について、各種設定の確認/変更ができます。',
    },
    FECU20ニックネーム設定画面: {
      C0001: '入力された内容で登録します。\nよろしいでしょうか。',
      C0002:
        '対象地区のニックネーム変更を行うことができます。\nニックネームは、対象地区の一覧や一括ユーザー警備操作等に表示されます。\n対象地区の一覧表示はニックネームの昇順にソートされますので、表示順を変更したい場合は、ニックネームを変更してください。\nニックネームは、お客様独自で使用いただくものです。ALSOKへのお問い合わせの際は地区正式名称をお伝えください。',
      C0003: 'ニックネーム登録が完了しました。',
      E0001: 'ニックネームは必ず入力してください。',
      E0002: 'ニックネームは半角・全角文字で入力してください。',
      E0004: '登録に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU20-E0004）',
    },
    FECU21IDカードキー情報設定画面: {
      C0001:
        'IDカード/キーのニックネームの変更や有効/無効の設定を行うことができます。\nニックネームは、IDカード/キーにより警備操作をした際に、通知履歴画面で表示されます。',
      C0002: '入力された内容で設定します。\nよろしいでしょうか。',
      C0004: '設定が完了していません。\n画面を移動しますか。',
      E0001: 'ニックネームは必ず入力してください。',
      E0002: 'ニックネームは半角文字もしくは全角文字（JIS X 0208相当）で入力してください。',
      E0004: '設定に失敗しました。\nもう一度設定してください。\n（エラーコード：FE-CU21-E0004）',
      E0006:
        'カード情報の取得に失敗しました。\n画面をもう一度更新してください。。\n（エラーコード：FE-CU21-E0006）',
    },
    FECU22通知配信設定画面: {
      C0001:
        '対象地区のPUSH通知/Eメール通知の設定を行うことができます。\n特定の通知のみ受信したい場合は、通知するを選択し、必要な通知のみチェックをつけて設定してください。\n通知しないを選択した場合、PUSHやEメールでは通知しませんが、通知履歴画面から通知内容の確認が可能です。',
      C0002: '設定された内容で登録します。\nよろしいでしょうか。',
      E0001: '登録に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU22-E0001）',
      E0002: 'プッシュ通知のチェック項目を1つ以上選択してください。',
      E0003: 'Eメール通知のチェック項目を1つ以上選択してください。',
    },
    FECU23見守り情報配信設定画面: {
      C0001:
        '見守り情報配信サービスについて、見守り方法の設定ができます。\n見守り方法は次の3種類があり、お客様の状況に応じて選択することができます。\n選択した見守り方法に合わせて、見守り設定時間やメールを配信する時刻を設定することもできます。\n・定期連絡：一定の時間間隔で、正常、異常の発生情報をメール/PUSH通知で受け取りたい場合\n・異常通知：設定した時間内にセンサーが作動しなかった場合に、異常の発生情報をメール/PUSH通知で受け取りたい場合\n・定刻連絡：異常通知に加え、指定した時刻に正常、異常の発生情報をメール/PUSH通知で受け取りたい場合\n※開始操作忘れ通知：見守り開始操作が行われていないときにメール/PUSH通知を受け取ることができます。',
      C0002:
        '入力された内容で設定します。お客様番号：{0}の対象地区すべてに反映されます。\nよろしいでしょうか。',
      C0003: '見守り情報配信設定が完了しました。',
      C0004:
        '設定された内容は全ての対象地区へ反映されます。\n設定された内容で登録します。\nよろしいでしょうか。',
      E0001: '登録に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU23-E0001）',
      E0002: '定期連絡時間は必ず入力してください。',
      E0003: '定期連絡時間は半角数字で入力してください。',
      E0004: '定期連絡時間は5～900分の間で入力してください。',
      E0005: '定刻連絡時刻①は必ず入力してください。',
      E0006: '定刻連絡時刻①は時刻を入力してください。',
      E0007: '定刻連絡時刻①に定刻連絡時刻②③と同じ時刻は入力できません。',
      E0008: '定刻連絡時刻②は時刻を入力してください。',
      E0009: '定刻連絡時刻②に定刻連絡時刻①③と同じ時刻は入力できません。',
      E0010: '定刻連絡時刻③は時刻を入力してください。',
      E0011: '定刻連絡時刻③に定刻連絡時刻①②と同じ時刻は入力できません。',
      E0012: '操作忘れ監視タイマは必ず入力してください。',
      E0013: '操作忘れ監視タイマは半角数字で入力してください。',
      E0014: '操作忘れ監視タイマは1～99時間の間で入力してください。',
      E0015: '配信時間Fromは必ず入力してください。',
      E0016: '配信時間Fromは半角数字で入力してください。',
      E0018: '配信時間Toは必ず入力してください。',
      E0019: '配信時間Toは半角数字で入力してください。',
      E0025: '異常通知時間は必ず入力してください。',
      E0026: '異常通知時間は半角数字で入力してください。',
      E0027: '異常通知時間は5～900分の間で入力してください。',
      E0028: '定刻連絡時間は必ず入力してください。',
      E0029: '定刻連絡時間は半角数字で入力してください。',
      E0030: '定刻連絡時間は5～900分の間で入力してください。',
      E0031: '定刻連絡時刻は1つ以上入力してください',
    },
    FECU24機器制御画面: {
      C0001:
        '設置している機器のブザーやライトの遠隔操作を行うことができます。\nセンサーが異常を検知したことで起動したブザーやライトはこの画面で停止することはできません。',
      C0002: '設定された内容で登録します。\nよろしいでしょうか。',
      E0001: '登録に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU24-E0001）',
      E0002:
        '読み込みに失敗しました。\n画面をもう一度更新してください。\n（エラーコード：FE-CU24-E0002）',
    },
    FECU25カメラ画面: {
      C0001:
        'ご利用中のユーザーに登録されたカメラの一覧が表示されています。\n各カメラに表示されているアイコンは、ユーザーがそのカメラで利用できる機能を示しています。\n各カメラを押下することで詳細を確認することができます。\n\n通知履歴(24時間以内)タブには、一覧に表示されたカメラの通知が表示されます。',
    },
    FECU26カメラ詳細画面: {
      C0001:
        'カメラとカメラが設置された地区の現在の状態が表示されています。\n各ボタンからより詳しい情報を確認いただけます。\n・カメラ映像ボタン\nカメラ用のアプリが起動し、現在の映像を確認できます。\n・依頼駆けつけボタン\nALSOKに対象地区への依頼駆けつけ(有償)を行うことができます。\n・通知履歴ボタン\nご利用ユーザー宛に発信された通知履歴を確認することができます。\n・ALSOKへのお問い合わせボタン\nお問い合わせのための連絡先を確認することができます。\n・カメラ設定ボタン\nカメラの設定画面を開きます。(カメラ本体の詳しい設定は、カメラ用のアプリにてご確認ください。)\n\n通知履歴(24時間以内)タブには、カメラの通知が表示されます。(通知/通知履歴の権限がない場合は表示されません)',
    },
    FECU27カメラ設定画面: {
      C0001: 'カメラについて、各種設定の確認/変更ができます。',
    },
    FECU28ニックネーム設定画面カメラ: {
      C0001:
        'カメラのニックネーム変更を行うことができます。\nニックネームは、カメラの一覧や通知履歴等に表示されます。\nカメラの一覧表示はニックネームの昇順にソートされますので、表示順を変更したい場合は、ニックネームを変更してください。',
      C0002: '入力された内容で登録します。\nよろしいでしょうか。',
      C0003: 'ニックネーム登録が完了しました。',
      E0001: 'ニックネームは必ず入力してください。',
      E0003: 'ニックネームは半角・全角文字で入力してください。',
      E0004: '登録に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU28-E0004）',
    },
    FECU29通知配信設定画面カメラ: {
      C0001:
        'カメラのPUSH通知/Eメール通知の設定を行うことができます。\n特定の通知のみ受信したい場合は、通知するを選択し、必要な通知のみチェックをつけて設定してください。\n通知しないを選択した場合、PUSHやEメールでは通知しませんが、通知履歴画面から通知内容の確認をしていただくことが可能です。',
      C0002: '設定された内容で登録します。\nよろしいでしょうか。',
      C0003: '通知配信設定が完了しました。',
      E0001: '登録に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU29-E0001）',
      E0002: 'プッシュ通知のチェック項目を1つ以上選択してください。',
      E0003: 'Eメール通知のチェック項目を1つ以上選択してください。',
    },
    FECU30ハウスサポート等お問い合わせ画面: {
      C0001:
        '健康相談等のお問い合わせの電話番号やWEBページのリンクが表示されます。\nスマートフォンをご利用の場合は、電話番号を押すと電話アプリが起動します。\n画面に表示されている注意事項をご確認の上お電話ください。',
      E0001:
        'アプリの起動に失敗しました。もう一度電話番号ボタンを押してください。\n（エラーコード：FE-CU30-E0001）',
    },
    FECU31各種設定画面: {
      C0001:
        'アカウント管理（対象地区）/アカウント管理（カメラ）/アカウント管理（ユーザー情報）/ログイン方法(*1)の設定項目を選択し、各画面から設定を行うことができます。\n*1:ログイン方法はスマートフォンアプリのみ設定を行うことができます。',
      C0002:
        'アカウント管理(対象地区)はWEBブラウザで表示します。\nこの際、アプリからはログアウトされます。\nアカウント管理(対象地区)を表示しますか。',
      C0003:
        'アカウント管理(カメラ)はWEBブラウザで表示します。\nこの際、アプリからはログアウトされます。\nアカウント管理(カメラ)を表示しますか。',
      C0004:
        'アカウント管理(ユーザー情報)はWEBブラウザで表示します。\nこの際、アプリからはログアウトされます。\nアカウント管理(ユーザー情報)を表示しますか。',
    },
    FECU32アカウント管理対象地区画面: {
      C0001:
        'ご利用中のユーザーに登録された対象地区の一覧が表示されます。\n各対象地区に表示された項目を押すことで以下の操作が可能です。\nユーザー管理：登録されたサブユーザーの変更\n緊急連絡先：警備先に登録された緊急連絡先情報の変更',
    },
    FECU33アカウント管理カメラ画面: {
      C0001:
        'ご利用中のユーザーに登録されたカメラの一覧が表示されます。\n各対象地区に表示された項目を押すことで以下の操作が可能です。\nユーザー管理：登録されたサブユーザーの変更\n緊急連絡先：警備先に登録された緊急連絡先情報の変更',
      C0002: '表示のカメラを削除します。\nよろしいでしょうか。',
      C0003: '削除が完了しました。',
      E0001:
        '削除に失敗しました。\nもう一度削除処理を行ってください。\n（エラーコード：FE-CU33-E0003）',
    },
    FECU34アカウント管理ユーザー情報画面: {
      C0001:
        'ご利用のユーザーのアカウント情報を表示しています。「変更」ボタンから各項目の設定変更を行うことができます。',
    },
    FECU35ログイン方法設定画面: {
      C0001:
        'ログイン方法を変更を行うことができます。\nご利用のスマートフォンによっては、生体認証がご利用になれない場合がございます。',
      C0002: '設定された内容で登録します。\nよろしいでしょうか。',
      C0003: '設定が完了しました。',
      C0004: '設定が完了していません。\n画面を移動しますか。',
    },
    FECU36パスコード設定画面: {
      C0001:
        'アプリのパスコードを設定・変更を行うことができます。\n設定したパスコードは、ログイン時に使用しますので、大切に保管してください。',
      C0002:
        'パスコードの設定が完了しました。\n生体情報が登録されていません。\n設定を開き、生体認証を設定しますか？',
      C0003: 'パスコードの設定が完了しました。',
      E0001: 'パスコードは半角数字のみで入力してください。',
      E0002: '確認用パスコードが一致しません。\nもう1度最初から入力してください。',
      E0003: '設定に失敗しました。\nもう一度入力してください。\n（エラーコード：FE-CU36-E0003）',
    },
    FECU37ユーザー管理画面: {
      C0001:
        '表示された対象地区またはカメラに登録されているユーザーの一覧を表示しています。\n「変更」ボタンを押して各画面より設定・変更を行うことができます。\n「サブユーザー追加」ボタンからは新しいサブユーザーの追加が可能です。\n「メインユーザー移譲」ボタンからは登録済みのサブユーザーにメインユーザー権限を移譲することができます。\n「メインユーザー移譲」ボタンはご利用中のユーザーが対象地区またはカメラのメインユーザーになっている場合に選択できます。',
    },
    FECU38サブユーザー権限変更画面: {
      C0001:
        'サブユーザーの権限を変更を行うことができます。\n「おすすめボタン」を押すとALSOKがおすすめする権限設定が表示されます。\n「対象地区から除外する」/「カメラから除外する」にチェックをつけて設定をすると、対象ユーザーを対象地区/カメラから除外します。\n除外することにより、登録されている地区・カメラの数が0になる場合は、ユーザーが削除されます。\n各操作権限でできることについては、マニュアルをご確認ください。',
      C0002: '設定された内容で登録します。\nよろしいでしょうか。',
      C0003:
        'このユーザーに関係する対象地区/カメラが0件になるため、ユーザー情報を削除します。よろしいでしょうか。',
      E0001: '設定に失敗しました。\nもう一度設定してください。\n（エラーコード：FE-CU38-E0001）',
    },
    FECU39新規サブユーザー登録画面仮登録: {
      C0001:
        '新規サブユーザーの仮登録を行うことができます。\n「おすすめボタン」を押すとALSOKがおすすめする権限設定が表示されます。\n入力したメールアドレス宛てにワンタイムURLを記載したメールが送信されます。ワンタイムURLへアクセスして手続きを進めてください。\n各操作権限でできることについては、マニュアルをご確認ください。',
      C0002: '入力された内容で仮登録します。\nよろしいでしょうか。',
      E0001: '入力されたメールアドレスは既に登録済みです。\n（エラーコード：FE-CU39-E0001）',
      E0002: '仮登録に失敗しました。\nもう一度登録してください。\n（エラーコード：FE-CU39-E0002）',
      E0003: 'メールアドレスの形式が正しくありません。',
      E0004: '確認用メールアドレスの形式が正しくありません。',
      C0005: '登録が完了しました。',
      E0005: 'メールアドレスは必ず入力してください。',
      E0006: '確認用メールアドレスは必ず入力してください。',
      E0007: 'メールアドレスと確認用メールアドレスが一致しません。',
    },
    FECU40メインユーザー移譲画面: {
      C0001:
        'メインユーザーを指定のサブユーザーに移譲することができます。\nサブユーザーの承認後、移譲が完了します。\n移譲が完了した後、ご利用中のユーザーはサブユーザーに変更されます。',
      C0002: 'メインユーザーを移譲します。\nよろしいでしょうか。',
      C0003: 'パスワードを入力してください。',
      E0001: 'パスワードは必ず入力してください。',
      E0004: 'パスワードは20字以内で入力してください。',
      E0005:
        'パスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。',
      C0004: '移譲のリクエストを送信しました。',
      E0006:
        'メインユーザー移譲処理に失敗しました。\nもう1度実行してください。\n（エラーコード：FE-CU40-E0006）',
    },
    FECU41承認可否選択画面: {
      C0001:
        '画面に表示された内容を確認し、「承認」か「否認」を選択してください。\n承認を行うと変更が反映され、否認を行うと変更がキャンセルされます。',
      C0002: '変更を承認します。\nよろしいでしょうか。',
      C0003: '変更を否認します。\nよろしいでしょうか。',
      C0004: '変更を承認しました。',
      C0005: '変更を否認しました。\n変更内容はキャンセルされました。',
      C0006: 'サブユーザーの登録を承認します。\nよろしいでしょうか。',
      C0007: 'サブユーザーの登録を否認します。\nよろしいでしょうか。',
      C0008: 'サブユーザーの登録を承認しました。',
      C0009: 'サブユーザーの登録を否認しました。\n登録はキャンセルされました。',
      C0010: 'ユーザー情報の変更を承認します。\nよろしいでしょうか。',
      C0011: 'ユーザー情報の変更を否認します。\nよろしいでしょうか。',
      C0012: 'ユーザー情報の変更を承認しました。',
      C0013: 'ユーザー情報の変更を否認しました。\n変更はキャンセルされました。',
      E0001:
        'メインユーザーの移譲に失敗しました。\nもう1度実行してください。\n(エラーコード：FE-CU41-E0001)',
      E0002:
        'サブユーザーの登録に失敗しました。\nもう1度実行してください。\n(エラーコード：FE-CU41-E0002)',
      E0003: 'ユーザー情報の変更に失敗しました。\nもう1度実行してください。',
    },
    FECU42緊急連絡先設定画面: {
      C0001:
        '緊急連絡先、同居家族情報、救急情報の登録を行うことができます。\n緊急連絡先は0件にすることはできません。最大5件まで登録することができます。\n同居家族情報は最大7件登録することができます。\nシークレットコードは、同居家族の方からALSOKへ連絡をいただいた際に、本人確認のため使用いたします。\n救急情報はご契約いただいた方のみ登録が可能です。最大2件登録することができます。\n救急情報は、あらかじめ持病やかかりつけの病院などの情報を登録しておき、万一救急搬送が必要になった場合、救急隊員に情報を引き継ぎます。',
      C0002: '入力された内容で登録します。\nよろしいでしょうか。',
      C0003: '表示の緊急連絡先を削除します。\nよろしいでしょうか。',
      C0004: '登録が完了しました。',
      C0005: '削除が完了しました。',
      C0006: '並び順が適用されました。',
      C0007: '並び順が適用されていません。\n画面を移動しますか。',
      C0008: '変更が完了しました。',
      E0001: '氏名は必ず入力してください。',
      E0003: '氏名(カナ)は必ず入力してください。',
      E0005: '氏名(カナ)は全角カタカナで入力してください。',
      E0006: '関係は必ず入力してください。',
      E0008: '電話番号は必ず入力してください。',
      E0010: '電話番号は半角数字と「-(ハイフン)」で入力してください。',
      E0011: '変更に失敗しました。\nもう一度変更してください。\n（エラーコード：FE-CU42-E0011）',
      E0012: '追加に失敗しました。\nもう一度追加してください。\n（エラーコード：FE-CU42-E0012）',
      E0013: '削除に失敗しました。\nもう一度削除してください。\n（エラーコード：FE-CU42-E0013）',
      E0014:
        '緊急連絡先情報の取得に失敗しました。\n画面をもう一度更新してください。\n（エラーコード：FE-CU42-E0014）',
      E0015: '緊急連絡先情報が登録されていません。\n（エラーコード：FE-CU42-E0015）',
      E0016:
        '並び替えに失敗しました。\nもう一度操作してください。\n（エラーコード：FE-CU42-E0016）',
    },
    FECU43緊急連絡先設定画面同居家族情報: {
      C0003: '表示の同居家族情報を削除します。\nよろしいでしょうか。',
      E0004: 'シークレットコード(フリガナ)は全角カタカナで入力してください。',
      E0006: '氏名は必ず入力してください。',
      E0008: '氏名(カナ)は必ず入力してください。',
      E0010: '氏名(カナ)は全角カタカナで入力してください。',
      E0011: '続柄は必ず選択してください。',
      E0012: '続柄は必ず入力してください。',
      E0014: '生年月日は必ず入力してください。',
      E0015: '変更に失敗しました。\nもう一度変更してください。\n（エラーコード：FE-CU43-E0015）',
      E0016: '追加に失敗しました。\nもう一度追加してください。\n（エラーコード：FE-CU43-E0016）',
      E0017: '削除に失敗しました。\nもう一度削除してください。\n（エラーコード：FE-CU43-E0017）',
      E0018:
        'シークレットコードとシークレットコード(フリガナ)は両方入力するか両方空白にしてください。',
      E0019: '同居家族が登録されていません。\n（エラーコード：FE-CU43-E0019）',
      E0020: '同居家族情報の取得に失敗しました。\n（エラーコード：FE-CU43-E0020）',
      E0021:
        '並び替えに失敗しました。\nもう一度操作してください。\n（エラーコード：FE-CU43-E0021）',
    },
    FECU44緊急連絡先設定画面救急情報: {
      C0002: '表示の救急情報を削除します。\nよろしいでしょうか。',
      E0001: '削除に失敗しました。\nもう一度削除してください。\n（エラーコード：FE-CU44-E0001）',
      E0002: '救急情報の取得に失敗しました。\n（エラーコード：FE-CU44-E0002）',
    },
    FECU45救急情報設定画面: {
      C0001:
        '救急情報の登録を行ってください。\nガードマンが駆けつけた際、万一救急搬送が必要になった場合に、救急隊員に登録いただいた情報を引き継ぎます。',
      E0001: '氏名は必ず入力してください。',
      E0003: '氏名(カナ)は必ず入力してください。',
      E0005: '氏名(カナ)は全角カタカナで入力してください。',
      E0006: '性別は必ず入力してください。',
      E0007: '生年月日は必ず入力してください。',
      E0008: '生年月日は半角数字記号で入力してください。',
      E0010: '入力が不正です。',
      E0011: '既往症(病名)は必ず入力してください。',
      E0013: '名称(医療機関名)は必ず入力してください。',
      E0015: '住所は必ず入力してください。',
      E0017: '電話番号は必ず入力してください。',
      E0018: '電話番号は半角数字と「-(ハイフン)」で入力してください。',
      E0020: '担当医師は必ず入力してください。',
      E0022: '設定に失敗しました。\nもう一度設定してください。\n（エラーコード：FE-CU45-E0022）',
      E0028: '内容が更新されました。\nもう一度設定してください。\n（エラーコード：FE-CU45-E0028）',
    },
    FECU46サービス追加画面: {
      C0001:
        'アプリやWEBサイトで利用するサービスを追加いたします。\nホームセキュリティを追加する場合は、ALSOKよりお伝えした、「お客様番号」「認証番号」を入力してください。\nカメラを追加する場合は、カメラ用アプリから「デバイスID」を確認し、入力してください。\nセルフセキュリティやオンラインセキュリティなどのサービスに付随するカメラを登録する場合は、カメラ登録時に「お客様番号」「認証番号」を入力してください。\nその他サービスを追加する場合は、追加したいサービスにチェックをつけてください。',
      C0002: '入力された内容で登録します。\nよろしいでしょうか。',
      C0004: 'カメラを設置する地区を選択してください。',
      C0005: 'HomeLinkの認証画面(別サイト)を開きます。',
      C0006: '登録が完了しました。',
      E0001: 'お客様番号は必ず入力してください。',
      E0002: 'お客様番号は半角数字で入力してください。',
      E0004: '製造番号は必ず入力してください。',
      E0005: '製造番号は半角英数で入力してください。',
      E0007: '認証番号は必ず入力してください。',
      E0009: 'デバイスIDは必ず入力してください。',
      E0011: 'デバイスIDは半角英数字で入力してください。',
      E0012:
        '登録しようとしているサービスには既にメインユーザーが登録済みです。\n（エラーコード：FE-CU46-E0012）',
      E0013:
        'サービスの追加に失敗しました。\n入力内容をご確認の上もう1度登録してください。\n（エラーコード：FE-CU46-E0013）',
      E0015: '認証番号は半角数字で入力してください。',
      E0016:
        'お客様番号/認証番号に誤りがあります。\n入力内容をご確認の上もう1度登録してください。\n（エラーコード：FE-CU46-E0016）',
      E0017:
        'サービスの追加に失敗しました。\nHomeLinkの登録内容をご確認ください。\n（エラーコード：FE-CU46-E0017）',
      E0018:
        'お客様番号/認証番号に誤りがあります。\n入力内容をご確認の上もう1度登録してください。\n（エラーコード：FE-CU46-E0018）',
      E0019:
        '認証に失敗しました。\nHomeLinkの登録内容をご確認ください。\n（エラーコード：FE-CU46-E0019）',
    },
    FECU47ユーザー情報変更画面氏名電話番号: {
      C0001: 'ご利用中のユーザーの氏名、性別、生年の設定・変更を行うことができます。',
      C0002: '入力された内容で変更します。\nよろしいでしょうか。',
      E0001: '氏名は必ず入力してください。',
      E0006:
        'ユーザー情報(氏名)の変更に失敗しました。\nもう一度設定してください。\n（エラーコード：FE-CU47-E0006）',
    },
    FECU48ユーザー情報変更画面メールアドレス: {
      C0001:
        'ご利用中のユーザーのユーザーID(メールアドレス）の変更を行うことができます。\n新しく設定したメールアドレス宛にワンタイムURLが送信されます。ワンタイムURLへアクセスして手続きを進めてください。',
      C0002: '入力された内容で変更します。\nよろしいでしょうか。',
      C0003: 'パスワードを入力してください。',
      E0001: 'ユーザーID(メールアドレス)は必ず入力してください。',
      E0002: '確認用ユーザーID(メールアドレス)は必ず入力してください。',
      E0003: 'ユーザーID(メールアドレス)と確認用ユーザーID(メールアドレス)が一致しません。',
      E0004: 'パスワードは必ず入力してください。',
      E0005: '入力されたパスワードが間違っています。\n（エラーコード：FE-CU48-E0005）',
      E0006: 'ユーザーID(メールアドレス)の形式が正しくありません。',
      E0007: '確認用ユーザーID(メールアドレス)の形式が正しくありません。',
      E0012:
        'ユーザー情報(メールアドレス)の変更に失敗しました。\nもう一度設定してください。\n（エラーコード：FE-CU48-E0012）',
    },
    FECU49ユーザー情報変更画面パスワード: {
      C0001:
        'ご利用中のユーザーのログイン時のパスワードの変更を行うことができます。\n推測されにくいパスワードを登録してください。',
      C0002: 'パスワードを変更します。\nよろしいでしょうか。',
      E0001: '現在のパスワードは必ず入力してください。',
      E0002: '変更後のパスワードは必ず入力してください。',
      E0003: '確認用パスワードは必ず入力してください。',
      E0004: '変更後のパスワードと確認用パスワードが一致しません。',
      E0005: '入力されたパスワードが間違っています。\n（エラーコード：FE-CU49-E0005）',
      E0009:
        '変更後のパスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。',
      E0011:
        '確認用パスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。',
      E0012:
        'ユーザー情報(パスワード)の変更に失敗しました。\nもう一度設定してください。\n（エラーコード：FE-CU49-E0012）',
      E0013: 'パスワードは8文字以上入力ください。',
    },
    FECU50ユーザー情報変更秘密の質問: {
      C0001:
        'ご利用中のユーザーの秘密の質問/回答の変更を行うことができます。\n秘密の質問/回答はパスワードを初期化時に必要となりますので、大切に保管してください。',
      C0002: '秘密の質問を変更します。\nよろしいでしょうか。',
      C0003: 'パスワードを入力してください。',
      E0003: '回答は必ず入力してください。',
      E0005: '入力されたパスワードが間違っています。\n（エラーコード：FE-CU50-E0005）',
      E0006: '秘密の質問は必ず入力してください。',
      E0010: '回答はひらがなで入力してください。',
      E0011:
        'ユーザー情報(秘密の質問)の変更に失敗しました。\nもう一度設定してください。\n（エラーコード：FE-CU50-E0011）',
    },
    FECU51アカウント削除画面: {
      C0001:
        'ご利用中のユーザーのアカウントを削除します。\nご利用中のユーザーがメインユーザーとなっている地区/カメラにサブユーザーが登録されている場合は、アカウントの削除ができません。\nサブユーザーにメインユーザー権限を移譲するか、すべてのサブユーザーを地区/カメラから除外してからアカウントの削除を実施してください。',
      C0002:
        'あなたは、以下のホームセキュリティまたはカメラのメインユーザーです。\nアカウントの削除操作を行いますか。',
      E0001: 'パスワードは必ず入力してください。',
      E0003: '入力されたパスワードが間違っています。\n（エラーコード：FE-CU51-E0003）',
      E0004:
        'サブユーザーが紐づいているため、メインユーザーの削除ができません。\n（エラーコード：FE-CU51-E0004）',
    },
    FECU52新規メインユーザー登録画面仮登録: {
      C0001:
        '新規ユーザーの仮登録を行います。\nホームセキュリティで登録する場合は、ALSOKよりお伝えした、「お客様番号」「認証番号」を入力してください。\nカメラで登録する場合は、カメラ用アプリから「デバイスID」を確認し、入力してください。\nセルフセキュリティやオンラインセキュリティなどのサービスに付随するカメラを登録する場合は、カメラ登録時に「お客様番号」「認証番号」を入力してください。\n仮登録完了後、入力したメールアドレスにワンタイムURLを記載したメールが送信されますので、そちらから本登録を行ってください。',
      C0002: '入力された内容で仮登録します。\nよろしいでしょうか。',
      C0004: 'カメラを設置する地区を選択してください。',
      E0001: 'お客様番号は必ず入力してください。',
      E0003: 'お客様番号は半角数字で入力してください。',
      E0004: '製造番号は必ず入力してください。',
      E0006: '製造番号は半角英数字で入力してください。',
      E0007: '認証番号は必ず入力してください。',
      E0008: 'ユーザーID(メールアドレス)は必ず入力してください。',
      E0009: '確認用ユーザーID(メールアドレス)は必ず入力してください。',
      E0010: 'ユーザーID(メールアドレス)と確認用ユーザーID(メールアドレス)が一致しません。',
      E0012: 'デバイスIDは必ず入力してください。',
      E0014: 'デバイスIDは半角英数字で入力してください。',
      E0015: '入力されたお客様番号には、既にメインユーザーが登録済みです。',
      E0016:
        'サービスの追加に失敗しました。\n入力内容をご確認の上もう1度登録してください。\n（エラーコード：FE-CU52-E0016）',
      E0018: '認証番号は半角数字で入力してください。',
      E0019: 'ユーザーID(メールアドレス)の形式が正しくありません。',
      E0020: '確認用ユーザーID(メールアドレス)の形式が正しくありません。',
      E0021:
        'お客様番号/認証番号/メールアドレスに誤りがあります。\n入力内容をご確認の上もう1度登録してください。\n既にサービス利用中の場合は、ログイン後にサービス追加を行ってください。\n（エラーコード：FE-CU52-E0021）',
      E0022:
        'サービスの追加に失敗しました。\nHomeLinkの登録内容をご確認ください。\n（エラーコード：FE-CU52-E0022）',
      E0023:
        'お客様番号/認証番号/メールアドレスに誤りがあります。\n入力内容をご確認の上もう1度登録してください。\n既にサービス利用中の場合は、ログイン後にサービス追加を行ってください。\n（エラーコード：FE-CU52-E0023）',
      E0024:
        '登録しようとしているサービスには既にメインユーザーが登録済みです。\n（エラーコード：FE-CU52-E0024）',
      E0025:
        '認証に失敗しました。\nHomeLinkの登録内容をご確認ください。\n（エラーコード：FE-CU52-E0025）',
    },
    FECU53ユーザー登録画面本登録: {
      C0001:
        'ユーザーの本登録を行います。\n秘密の質問はパスワード初期化時に必要となりますので、大切に保管してください。\nパスワードは推測されにくい値を設定してください。',
      E0001: '氏名は必ず入力してください。',
      E0003: 'パスワードは必ず入力してください。',
      E0004: '確認用パスワードは必ず入力してください。',
      E0005: 'パスワードと確認用パスワードが一致しません。',
      E0006: '秘密の質問は必ず入力してください。',
      E0008: '回答は必ず入力してください。',
      E0012:
        '本登録処理に失敗しました。\nもう一度本登録処理を行ってください。\n（エラーコード：FE-CU53-E0012）',
      E0014:
        'パスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。',
      E0016:
        '確認用パスワードは半角で英字大文字、英字小文字、数字、記号のうち3種類以上使用してください。',
      E0017: '回答はひらがなで入力してください。',
      E0019: 'パスワードは8文字以上入力してください。',
      E0020: '確認用パスワードは8文字以上入力してください。',
      E0023: '本ユーザーは既に登録済みです。\n（エラーコード：FE-CU53-E0023）',
    },
    FECU54Thanks画面: {
      E0001:
        'アプリの起動に失敗しました。\nもう一度「担当ガードセンターもしくはALSOKコールセンターまでご連絡ください。」を押してください。\n（エラーコード：FE-CU54-E0001）',
    },
    FECU56利用規約画面: {
      C0001: '本サービスの利用規約となります。',
    },
    FECU57プライバシーポリシー画面: {
      C0001: '本サービスのプライバシーポリシーとなります。',
    },
    FECU58利用規約プライバシーポリシー同意画面: {
      C0001:
        '本サービスの利用規約/プライバシーポリシーをご確認いただき、ご同意いただけましたら、「同意します」を選択してください。',
    },
    FECU59ライセンス: {
      C0001: '本サービスのライセンス情報となります。',
    },
  },
  // ------------------------ 以下画面単位 -------------------------------------
  // FE-CU1 path: "/login",
  FECU01ログイン画面: {
    お客様Webサイト: 'HOMEALSOK',
    お客様アプリ: 'お客様アプリ',
    ユーザーIDを記憶する: 'ユーザーIDを記憶する',
    ログイン: 'ログイン',
    新規メインユーザー登録: '新規メインユーザー登録',
    パスワードを忘れた場合: 'パスワードを忘れた場合',
    ユーザーID: 'ユーザーID（メールアドレス）',
    パスワード: 'パスワード',
    パスコードでログイン: 'パスコードでログイン',
    キャンセルボタン: 'キャンセル',
    生体認証ボタン: '生体認証',
    エラー: 'エラー',
    ログインに失敗しました: 'ログインに失敗しました。',
    OKボタン: 'OK',
    認証に失敗しました: {
      生体認証: '認証に失敗しました。\n一定時間、生体認証をご利用頂けません。',
      パスコード: '認証に失敗しました。\n一定時間、パスコード認証をご利用頂けません。',
    },
    ALSOKからのお知らせ: 'ALSOKからのお知らせ',
    お知らせはありません: 'お知らせはありません',
    お知らせ日付: '{0}年{1}月{2}日{3}:{4}', // 数字は呼び出す際に付与する引数のindex
    健康相談等: '健康相談等',
    パスコードまたは生体認証でログイン: 'パスコードまたは生体認証でログイン',
  },
  // FE-CU2
  FECU02トップ画面: {
    トップ: 'トップ',
    通知履歴: '通知履歴',
    設定: '設定',
    日本語: '日本語',
    English: '英語',
    ユーザーマニュアル: 'ユーザーマニュアル',
    通販ショップ: '通販ショップ',
    利用規約: '利用規約',
    プライバシーポリシー: 'プライバシーポリシー',
    ライセンス情報: 'ライセンス情報',
    ログアウト: 'ログアウト',
    ヘルプ: 'ヘルプ',
    お知らせ: 'お知らせ',
    閉じるボタン: '閉じる',
    確認警告: '確認/警告',
    いいえボタン: 'いいえ',
    はい: 'はい',
    全て選択ボタン: '全て選択',
    クリアボタン: 'クリア',
    システムエラーが発生しました: {
      エラーコード有:
        'システムエラーが発生しました。\n（エラーコード：{0}）\nALSOK営業までご連絡ください。', //{0}はエラーコード,
      エラーコード無: 'システムエラーが発生しました。\nALSOK営業までご連絡ください。',
    },
    通信に失敗しました: '通信に失敗しました。\nしばらく時間をおいて再度実行ください。',
    警備ユニットとサーバー間の通信に失敗しました:
      '警備ユニットとサーバー間の通信に失敗しました。\nALSOKの担当事業所までご連絡ください。',
    ダイアログメッセージ:
      'スマートフォン・タブレットの生体認証が無効となっており利用できません。\nスマートフォン・タブレットの設定をご確認ください。',
    設定画面を開くボタン: '設定画面を開く',
    このまま使用するボタン: 'このまま使用する',
    内容が更新されました: '内容が更新されました。\n画面をもう一度更新してください。',
    カメラ: 'カメラ',
    ホームセキュリティ: 'ホームセキュリティ',
    ホームセキュリティモバイル: 'ホーム\nセキュリティ',
    //以下文言は設計書FE-CU02未記載だが、表示に必要なため追加
    対象地区選択: '対象地区選択',
    一括警備操作: '一括警備操作（対象地区選択）',
    新規メイン: '新規メイン',
    ユーザー登録: 'ユーザー登録',
    ライセンス: 'ライセンス',
    プライバシー: 'プライバシー',
    各種設定: '各種設定',
    サービス追加: 'サービス追加',
    開く: '開く',
    閉じる: '閉じる',
  },
  // FE-CU03_2段階認証画面 path: "/twoStepAuthentication",pages/user/oneTimePassword/Index.vue"
  FECU03二段階認証画面: {
    二段階認証: '二段階認証',
    // ご登録いただいているメールアドレスに:
    //   "ご登録いただいているメールアドレスに「{0}」メールを送信しました。{1}分以内にメール本文に記載されている認証コードを入力し、認証を完了させてください。", //{0}「●●（件名）」,{1}●分,
    ご登録いただいているメールアドレスに:
      'ご登録いただいているメールアドレスに「{0}（件名）」メールを送信しました。', //{0}「●●（件名）」,{1}●分,
    認証を完了させてください:
      '{0}分以内にメール本文に記載されている認証コードを入力し、認証を完了させてください。',
    ご利用の端末から: 'ご利用の端末から初めてのログインする場合、二段階認証が必要となります。', //設計書赤文字
    メールが届かない場合は以下の可能性が考えられます:
      'メールが届かない場合は、以下の可能性が考えられます。\nメールの設定を変更後、「<」または「戻る」ボタンでログイン画面に移動し、再度ログインを行ってください。',
    迷惑メールとして処理されている可能性があります:
      '迷惑メールとして処理されている可能性があります。\n迷惑メールフォルダやゴミ箱等に「{0}」という件名のメールがないか、ご確認をお願いいたします。', //{0}（件名）
    ドメイン指定を行っている方は:
      'ドメイン指定を行っている方は「{0}」を受信できる様に設定してください。', //{0}ドメイン名
    認証ボタン: '認証',
    戻るボタン: '戻る',
    認証コード: '認証コード',
  },
  // FE-CU04_パスワード初期化画面（ユーザーID入力） path: "/passwordInitUserIdEntry",pages/passwordInitUserIdEntry/Index.vue
  FECU04パスワード初期化画面ユーザーID入力: {
    パスワード初期化ユーザーID: 'パスワード初期化（ユーザーID）',
    ユーザーIDメールアドレス: 'ユーザーID（メールアドレス）',
    確認用: '確認用',
    メールを送信ボタン: 'メールを送信',
    戻るボタン: '戻る',
  },
  // FE-CU05_パスワード初期化画面（秘密の質問） path: "/passwordInitSecretQuestion",pages/passwordInitSecretQuestion/Index.vue
  FECU05パスワード初期化画面秘密の質問: {
    秘密の質問: '秘密の質問',
    回答ひらがな: '回答（ひらがな）',
    次へボタン: '次へ',
    回答が誤っています: '回答が誤っています。',
    OKボタン: 'OK',
    閉じるボタン: '閉じる',
    確認: '確認',
  },
  // FE-CU06_パスワード初期化画面（パスワード再登録） path: "/passwordInitReregistration",pages/passwordInitReregistration/Index.vue
  FECU06パスワード初期化画面パスワード再登録: {
    パスワード再登録: 'パスワード再登録',
    新しいパスワード: '新しいパスワード',
    確認用: '確認用',
    再登録ボタン: '再登録',
  },
  // FE-CU7
  FECU07: {
    トップ: 'トップ',
    ホームセキュリティ: 'ホーム',
    セキュリティ: 'セキュリティ',
    カメラ: 'カメラ',
    サービス追加: 'サービス追加',
    警備操作: '警備操作',
    対象地区: '対象地区',
    対象地区選択ボタン: '対象地区選択',
    外出: '外出',
    在宅: '在宅',
    解除: '解除',
    オンライン: 'ALSOK',
    警備: '警備中',
    セルフ: 'セルフ',
    設定ボタン: '設定',
    ホーム: 'ホーム',
    ALSOKからのお知らせ: 'ALSOKからのお知らせ',
    お知らせ日付: '{0}年{1}月{2}日{3}:{4}', // 数字は呼び出す際に付与する引数のindex
    一括警備操作: '一括警備操作\n（対象地区選択）',
    全て選択ボタン: '全て選択',
    クリアボタン: 'クリア',
    キャンセルボタン: 'キャンセル',
    適用ボタン: '適用',
    警報を解除しました: '{0}件中{1}件の地区の警報を解除しました。',
    対象地区名: '対象地区：{0}', //●●● no60,63,64で使用
    OKボタン: 'OK',
    警備操作が完了しました: '{0}件中{1}件の地区のユーザー警備操作が完了しました。',
    警備操作が失敗した地区があります: '以下の問題からユーザー警備操作に失敗した地区があります。',
    発生しました: '{0}が発生しました。',
    戸締まり状態が異常です: '戸締り状態が異常です。\n戸締り確認を行なってください。',
    警備します: '警備します。\nよろしいでしょうか。',
    在宅対象確認ボタン: '在宅対象確認',
    在宅対象エリア: '在宅対象エリア - {0}', //
    警備状態表示: {
      外出ALSOK警備中: '外出ALSOK警備中',
      在宅ALSOK警備中: '在宅ALSOK警備中',
      外出セルフ警備中: '外出セルフ警備中',
      在宅セルフ警備中: '在宅セルフ警備中',
      警備解除中: '警備解除中',
      ユーザ点検: 'ユーザ点検中',
    },
    一括警備操作を適用します: '一括警備操作の対象となる地区を適用します。\nよろしいでしょうか。',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    // 設計書にはないが必要だったため追加
    健康相談等: '健康相談等',
    アップ: 'お役立ち情報',
    グレード: '',
    確認: '確認',
    入力された内容で登録します: '入力された内容で登録します。\n\rよろしいでしょうか。',
    警備状態を変更: '警備状態を変更',
    お知らせ: 'お知らせ',
    複数選択中: '複数選択中',
    読点: '、',
    // PUSH通知確認ダイアログ
    設定をご確認ください:
      'スマートフォン・タブレットのPUSH通知設定が無効になっています。\n\rスマートフォン・タブレットの設定をご確認ください。',
    設定画面を開く: '設定画面を開く',
    このまま使用する: 'このまま使用する',
    選択できません: '「ALSOK」を選択できません',
    一括警備操作ダイアログ: {
      警備状態を変更できません:
        '指定した以下地区は警備状態を変更できませんでした。\n一度解除状態に変更後、警備操作をするか、契約種別をご確認ください。\n　・対象地区：{0}\n（エラーコード：FE-CU7-C0015）\n',
      警備状態を変更できません_解除:
        '指定した以下地区は警備状態を変更できませんでした。\nすでに解除されている場合があります。警備状態をご確認ください。\n　・対象地区：{0}\n（エラーコード：FE-CU7-C0016）\n',
      警備ユニットエラー:
        '・対象地区：{0}\n　警備ユニットがエラーを返しました。\n　もう一度操作を行ってください。\n（エラーコード：FE-CU7-C0013）\n',
      以下の問題: '以下の問題から警備が開始できなかった地区があります。\n',
      以下の問題から解除: '以下の問題から警備が解除できなかった地区があります。\n',
      戸締まり異常:
        '　戸締り状態が異常です。\n　戸締り確認を行ってください。\n（エラーコード：FE-CU7-C0014）\n',
      対象地区: '・対象地区：{0}\n',
    },
  },
  // FE-CU08_ホームセキュリティ画面 path: "/homeSecurity",pages/homeSecurity/HomeSecurity.vue
  FECU08ホームセキュリティ画面: {
    ホームセキュリティ: 'ホームセキュリティ',
    対象地区一覧ボタン: '対象地区一覧',
    通知履歴24時間以内ボタン: '通知履歴\n（24時間以内）',
    権限: {
      メインユーザー: 'メインユーザー',
      サブユーザー: 'サブユーザー',
      権限: '権限',
    },
    最終更新日時: '最終更新日時',
    最終更新日時データ: '{0}/{1}/{2} {3}:{4}:{5}', //{0}=yyyy,{1}=M,{2}=d,{3}=H,{4}=mm,{5}=ss
    通知日付: '{0}/{1}（{2}）', //{0}=M,{1}=d,{2}=曜日[月,火,水,木,金,土,日]
    HOMEALSOK: 'HOME ALSOK',
    通知時間: '{0}:{1}', //H:mm
    ニックネーム: 'ニックネーム',
    地区番号: '地区番号',
    加入サービス: '加入サービス',
    戻るボタン: '戻る',
  },
  // FE-CU09_対象地区詳細画面 path: "/displayDistrictDetail",pages/homeSecurity/AddressDetail.vue
  FECU09対象地区詳細画面: {
    対象地区メニュー: '対象地区メニュー',
    通知履歴24時間以内: '通知履歴\n（24時間以内）',
    対象地区詳細: '対象地区詳細',
    対象地区一覧: '対象地区一覧',
    権限: '権限',
    警備状態: '警備状態',
    警備状態データ: {
      外出ALSOK警備中: '外出 ALSOK 警備中',
      在宅ALSOK警備中: '在宅 ALSOK 警備中',
      外出セルフ警備中: '外出セルフ警備中',
      在宅セルフ警備中: '在宅セルフ警備中',
      警備解除中: '警備解除中',
      ユーザ点検中: 'ユーザ点検中',
    },
    警報発生: '警報発生',
    発報状態: { あり: 'あり', なし: 'なし' },
    戸締まり: '戸締り異常',
    戸締まり状態: { OK: 'なし', NG: 'あり' },
    新着通知24時間以内: '新着通知\n（24時間以内）',
    通知: '通知',
    ユーザー警備操作: 'ユーザー警備操作',
    かけつけ依頼: '依頼駆けつけ',
    通知履歴: '通知履歴',
    ALSOKへのお問い合わせ: 'ALSOKへのお問い合わせ',
    対象地区設定: '対象地区設定',
    機器制御: '機器制御',
    最終更新日時: '最終更新日時',
    最終更新日時データ: '{0}/{1}/{2} {3}:{4}:{5}', //{0}=yyyy,{1}=M,{2}=d,{3}=H,{4}=mm,{5}=ss
    日付: '{0}/{1}（{2}）', //{0}=M,{1}=d,{2}=曜日[月,火,水,木,金,土,日]
    通知時間: '{0}:{1}', //{0}=H,{1}=mm
    HOMEALSOK: 'HOME ALSOK',
    戻るボタン: '戻る',
    //追加
    対象地区詳細表示領域: {
      対象地区: '対象地区 - {0}', //対象地区 - 〇〇
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    メイン地区: 'メイン地区',
    対象地区: '対象地区',
    // ALSOKへのお問い合わせ
    ALSOKへの: 'ALSOKへの',
    お問い合わせ: 'お問い合わせ',
  },
  // FE-CU10_ユーザー警備操作画面 path: "/userSecurityOperation",pages/homeSecurity/securityControl/userSecurityControl/Index.vue
  FECU10ユーザー警備操作画面: {
    ユーザー警備操作: 'ユーザー警備操作',
    最終操作日時: '最終操作日時',
    最終操作日時データ: '{0}/{1}/{2}/（{3}） {4}:{5}:{6}', //{0}=yyyy,{1}=M,{2}=d,{3}=（ddd）,{4}=H,{5}=MM ,{6}=ss",
    最終操作者: '最終操作者',
    警報: '警報発生',
    警報データ: { 異常なし: 'なし', 異常あり: 'あり' },
    戸締り状態: '戸締り異常',
    戸締り状態データ: { 異常なし: 'なし', 異常あり: 'あり' },
    警備状態: '警備状態',
    警備状態データ: {
      外出ALSOK警備中: '外出 ALSOK 警備中',
      在宅ALSOK警備中: '在宅 ALSOK 警備中',
      外出セルフ警備中: '外出セルフ警備中',
      在宅セルフ警備中: '在宅セルフ警備中',
      警備解除中: '警備解除中',
      ユーザ点検中: 'ユーザ点検中',
    },
    警備操作: '警備操作',
    外出: '外出',
    在宅: '在宅',
    解除: '解除',
    オンライン: 'ALSOK',
    セルフ: 'セルフ',
    設定ボタン: '設定',
    警報確認: '警報確認',
    戸締り確認: '戸締り確認',
    在宅対象設定: '在宅対象設定',
    戻るボタン: '戻る',
    指定した地区は既に解除状態です: '指定した地区は既に解除状態です。',
    OKボタン: 'OK',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    在宅対象エリア: '在宅対象エリア - {0}',
    すべて選択ボタン: '全て選択',
    クリアボタン: 'クリア',
    キャンセルボタン: 'キャンセル',
    適用ボタン: '適用',
    //追加
    対象地区詳細: {
      対象地区: '対象地区',
      カメラ: 'カメラ',
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    メイン地区: 'メイン地区',
  },
  // FE-CU12_警報確認画面 path: "/alermConfirmation",pages/homeSecurity/securityControl/AlertConfirm.vue
  FECU12警報確認画面: {
    警報確認: '警報確認',
    警報: '警報',
    侵入: '侵入',
    非常: '非常/救急',
    火災: '火災',
    ガス: 'ガス',
    ライフリズム: 'ライフリズム',
    電池: '電池',
    機器異常: '機器異常',
    設備: '設備',
    戻るボタン: '戻る',
    //追加
    対象地区詳細: {
      対象地区: '対象地区', //対象地区 - 〇〇
      カメラ: 'カメラ', //カメラ - 〇〇
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      メイン地区: 'メイン地区',
    },
  },
  // FE-CU13_戸締り確認画面 path: "/lockConfirmation",pages/homeSecurity/securityControl/lockedConfirm/Index.vue
  FECU13戸締り確認画面: {
    戸締り確認: '戸締り確認',
    対象地区詳細表示領域: {
      対象地区: '対象地区',
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      メイン地区: 'メイン地区',
    },
    センサー状態エリア: 'センサー状態（エリア）',
    戸締まり状態: { 異常なし: '異常なし', 異常: '異常', 取得失敗: '取得失敗' },
    戻るボタン: '戻る',
    発報中: '発報中',
  },
  // FE-CU14_警報確認画面（センサー）path: "/sensorWarningConfirmation",/pages/homeSecurity/securityControl/alertConfirmSensor/Index.vue
  FECU14警報確認画面センサー: {
    警報確認センサー: '警報確認（センサー）',
    対象地区詳細表示領域: {
      対象地区: '対象地区',
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      メイン地区: 'メイン地区',
    },
    警報名: {
      侵入: '侵入',
      火災: '火災',
      ガス: 'ガス',
      非常救急: '非常/救急',
      ライフリズム: 'ライフリズム',
      設備: '設備',
      電池: '電池',
      機器異常: '機器異常',
    },
    検知状況: {
      異常なし: '異常なし',
      発報中: '発報中',
      異常: '異常',
      取得失敗: '取得失敗',
    },
    戻るボタン: '戻る',
  },
  // FE-CU15_戸締り確認（エリア）path: "/areaLockConfirmation",pages/homeSecurity/securityControl/lockedConfirmArea/Index.vue
  FECU15戸締り確認エリア: {
    戸締り確認エリア: '戸締り確認（エリア）',
    エリア: 'エリア',
    対象地区詳細表示領域: {
      対象地区: '対象地区',
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      メイン地区: 'メイン地区',
    },
    検知状況: {
      異常なし: '異常なし',
      発報中: '発報中',
      異常: '異常',
      取得失敗: '取得失敗',
    },
    戻るボタン: '戻る',
  },
  // FE-CU16_かけつけ依頼画面 path: "/emergencyRequest",/pages/rushInquiry/Index.vue
  FECU16かけつけ依頼画面: {
    かけつけ依頼: '依頼駆けつけ',
    対象地区詳細カメラ詳細表示領域: {
      対象地区: '対象地区 - {0}', //対象地区 - 〇〇
      カメラ: 'カメラ - {0}', //カメラ - 〇〇
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
    },
    メイン地区: 'メイン地区',
    対象地区: '対象地区',
    カメラ: 'カメラ',
    お客様番号: 'お客様番号',
    権限: { メインユーザー: 'メインユーザー', サブユーザー: 'サブユーザー' },
    警備状態: '警備状態',
    警備状態データ: {
      外出ALSOK警備中: '外出 ALSOK 警備中',
      在宅ALSOK警備中: '在宅 ALSOK 警備中',
      外出セルフ警備中: '外出セルフ警備中',
      在宅セルフ警備中: '在宅セルフ警備中',
      警備解除中: '警備解除中',
      ユーザ点検中: 'ユーザ点検中',
    },
    警報発生: '警報発生',
    警報発生データ: { あり: 'あり', なし: 'なし' },
    戸締まり: '戸締り異常',
    戸締まりデータ: { OK: 'なし', NG: 'あり' },
    通知: '通知',
    担当ガードセンタートパーズセンター: {
      担当ガードセンター: '担当ガードセンター：{0}',
      コールセンター: 'ALSOKコールセンター',
    },
    注釈表示領域: {
      担当ガードセンター: {
        架電: '電話アプリにて担当ガードセンターへ電話を掛けます。',
        架電画面表示の:
          '画面表示のお客様番号をお伝えください。\nまた、地区名をお伝えいただく場合は、地区正式名称をお伝えください。',
        電話のプランによって: '※電話のプランによって通話料金が発生する場合があります。',
        IP電話アプリや:
          '※IP 電話アプリや、別の電話機から電話発信する場合は、上記電話番号に直接ご連絡ください。',
        通話料金: '※電話のプランによって通話料金が発生する場合があります。',
        担当ガードセンターへ電話の際は:
          '担当ガードセンターへ電話の際は、画面表示のお客様番号をお伝えください。\nまた、地区名をお伝えいただく場合は、地区正式名称をお伝えください。',
      },
      セキュリティサービス部トパーズセンター: {
        SP架電: '電話アプリにてALSOKコールセンターへ電話を掛けます。',
        SP架電画面表示の:
          '画面表示のお客様番号をお伝えください。\nまた、地区名をお伝えいただく場合は、地区正式名称をお伝えください。',
        PC架電:
          'ALSOKコールセンターへ電話の際は、画面表示のお客様番号をお伝えください。\nまた、地区名をお伝えいただく場合は、地区正式名称をお伝えください。',
        電話のプランによって: '※電話のプランによって通話料金が発生する場合があります。',
        IP電話アプリや:
          '※IP 電話アプリや、別の電話機から電話発信する場合は、上記電話番号に直接ご連絡ください。',
      },
      有償です: '※依頼駆けつけは有償サービスです。',
    },
    戻るボタン: '戻る',
  },
  // FE-CU17_通知履歴画面 path: "/notificationHistory",pages/notificationHistory/Index.vue
  FECU17通知履歴画面: {
    通知履歴: '通知履歴',
    全通知ボタン: '全通知',
    ホームセキュリティボタン: 'ホームセキュリティ',
    カメラボタン: 'カメラ',
    お知らせボタン: 'お知らせ',
    最終更新日時: '最終更新日時',
    // 最終更新日時データ:"yyyy/M/d H:mm:ss",
    最終更新日時データ: '{0}/{1}/{2} {3}:{4}:{5}', //{0}=yyyy,{1}=M,{2}=d,{3}=H,{4}=mm,{5}=ss
    日付: '{0}/{1}（{2}）', //{0}=M,{1}=d,{2}=曜日[月,火,水,木,金,土,日]
    HOMEALSOK: 'HOME ALSOK',
    時間: '{0}:{1}', // H:mm
    新着: '新着',
    対象地区: '対象地区',
    警報種別: '警報種別',
    カメラ: 'カメラ',
    検知種別: '検知種別',
    対象地区選択: '対象地区選択',
    キャンセルボタン: 'キャンセル',
    適用ボタン: '適用',
    警報種別選択: '警報種別選択',
    警報種別選択チェックボックス: {
      警備操作: '警備操作',
      侵入: '侵入',
      火災: '火災',
      火災復旧: '火災-復旧',
      ガス: 'ガス',
      ガス復旧: 'ガス-復旧',
      非常救急: '非常/救急',
      非常救急復旧: '非常/救急-復旧',
      ライフリズム: 'ライフリズム',
      ライフリズム復旧: 'ライフリズム-復旧',
      設備: '設備',
      設備復旧: '設備-復旧',
      電池切れ: '電池切れ',
      電池切れ復旧: '電池切れ-復旧',
      機器異常: '機器異常',
      機器異常復旧: '機器異常-復旧',
      お知らせ: 'お知らせ',
      見守り: '見守り',
      すべての復旧: 'すべての復旧',
      その他: 'その他',
    },
    検知種別選択チェックボックス: {
      動体検知: '動体検知・ローバッテリー',
      その他: 'その他',
    },
    種別: '種別',
    ホーム: 'ホーム',
    セキュリティ: 'セキュリティ',
    お知らせ: 'お知らせ',
    ユーザー名: '[アプリ]',
    // 追加
    戻るボタン: '戻る',
    カメラ選択: 'カメラ選択',
    検知種別選択: '検知種別選択',
    全て選択: '全て選択',
    クリア: 'クリア',
    複数選択中: '複数選択中',
    全て: '全て',
    通知メッセージ: {
      前回ログイン以降の通知: '前回ログイン以降の通知',
      以前の通知を表示: '以前の通知を表示',
      以降の通知を表示: '以降の通知を表示',
      __が発生しました: '［{0}］が発生しました。',
      警備ユニットが__をセットしました: '警備ユニットが［{0}］をセットしました。', //未使用
      __をセットしました: '［{0}］をセットしました。',
      見守り監視は: '見守り監視は',
      です: 'です。',
      見守り状態を__しました: '見守り状態を［{0}］しました。', //未使用
      見守りは__しました: '見守りは［{0}］しました。', //未使用
      見守りの__しました: '見守りの［{0}］しました。', //未使用
      見守り監視に: '見守り監視に',
      が発生しています: 'が発生しています。',
      見守り監視が__しました: '見守り監視が［{0}］しました。',
      見守りの__が完了しました: '見守りの［{0}］が完了しました。', //未使用
      が解消しました: 'が解消しました。',
      __が解消しました: '［{0}］が解消しました。',
      見守り監視に__が発生しました: '見守り監視に［{0}］が発生しました。',
      __を解除しました: '［{0}］を解除しました。',
      __しました: '［{0}］しました。',
      __が復旧しました: '［{0}］が復旧しました。',
      になりました: 'になりました。',
      見守り監視は__しました: '見守り監視は［{0}］しました。',
      見守り監視は__を解除しました: '見守り監視は［{0}］を解除しました。',
      カメラが__しました: 'カメラが［{0}］しました。',
      カメラが: 'カメラが',
      になりましたC: 'になりました。',
      カメラの__が解消しました: 'カメラが［{0}］が解消しました。',
      詳細は: '詳細は',
      コチラ: 'コチラ',
      侵入警報: '侵入警報',
      火災警報: '火災警報',
      ガス警報: 'ガス警報',
      CO警報: 'CO警報',
      非常警報: '非常警報',
      救急警報: '救急警報',
      ライフリズム警報: 'ライフリズム警報',
      設備警報: '設備警報',
      A06: 'A06 電源接続状況を確認してください。',
      停電警報: '停電警報',
      A07: 'A07 充電してください。',
      ローバッテリー: 'ローバッテリー',
      A08: 'A08 ALSOKに連絡してください。',
      保護警報: '保護警報',
      A10: 'A10 ALSOKに連絡してください。',
      警備ユニット異常: '警備ユニット異常',
      A11: 'A11 ALSOKに連絡してください。',
      A12: 'A12 ALSOKに連絡してください。',
      A17: 'A17 ALSOKに連絡してください。',
      端末異常警報: '端末異常警報',
      無線端末異常: '無線端末異常',
      A18: 'A18 ALSOKに連絡してください。',
      A15: 'A15 ALSOKに連絡してください。',
      機器故障: '機器故障',
      A16: 'A16 ALSOKに連絡してください。',
      メッセージ認証不一致: 'メッセージ認証不一致',
      A13: 'A13 ネットワーク状況を確認し、改善しない場合ALSOKに連絡してください。',
      通信異常: '通信異常',
      A14: 'A14 ネットワーク状況を確認し、改善しない場合ALSOKに連絡してください。',
      断線: '断線',
      外出ALSOK警備: '外出ALSOK警備',
      在宅ALSOK警備: '在宅ALSOK警備',
      外出セルフ警備: '外出セルフ警備',
      在宅セルフ警備: '在宅セルフ警備',
      警備解除: '警備解除',
      強制警備: '強制警備',
      M02: 'M02 電池を交換してください。',
      電池電圧低下: '電池電圧低下',
      M03: 'M03 電源取得しているコンセントから他の機器を取り外してください。',
      過負荷: '過負荷',
      異常: '異常',
      定刻通報: '定刻通報',
      異常通報: '異常通報',
      監視停止中: '監視停止中',
      定刻異常中: '定刻異常中',
      見守り操作忘れ異常通報: '見守り操作忘れ異常通報',
      正常: '正常',
      復旧: '復旧',
      定期連絡: '定期連絡',
      定刻連絡: '定刻連絡',
      異常通知: '異常通知',
      見守り監視: '見守り監視',
      定刻正常: '定刻正常',
      設定変更完了: '設定変更完了',
      強制監視停止状態: '強制監視停止状態',
      動体検知: '動体検知',
      '002': '002 カメラを充電してください。',
      オフライン: 'オフライン',
      '003': '003 ネットワーク状況を確認し、改善しない場合ALSOKに連絡してください。',
      オンライン: 'オンライン',
      外出ALSOK警備操作: '外出ALSOK警備操作',
      在宅ALSOK警備操作: '在宅ALSOK警備操作',
      外出セルフ警備操作: '外出セルフ警備操作',
      在宅セルフ警備操作: '在宅セルフ警備操作',
      警備解除操作: '警備解除操作',
      ALSOKからのお知らせ: 'ALSOKからのお知らせ',
      定期通報: '定期通報',
    },
  },
  // FE-CU18_ALSOKへのお問い合わせ画面 path: "/contact",pages/inquiry/aboutContactAndItem/Index.vue
  FECU18ALSOKへのお問い合わせ画面: {
    ALSOKへのお問い合わせ: 'ALSOKへのお問い合わせ',
    対象地区詳細カメラ詳細表示領域: {
      対象地区: '対象地区', //対象地区 - 〇〇
      カメラ: 'カメラ', //カメラ - 〇〇
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム: 'ニックネーム\n（対象地区）',
    },
    お客様番号: 'お客様番号',
    その他のお問い合わせ: 'その他のお問い合わせ',
    受注事業所: '受注事業所：{0}', //受注事業所：●●
    受付時間: '【受付時間】 平日 9:00-18:00',
    警報機器トラブルに関するお問い合わせ: '警報・機器トラブルに関するお問い合わせ', // 警報・機器トラブルに関するお問い合わせ
    ガードセンター: 'ガードセンター：{0}', // ガードセンター：●●,
    トパーズセンター: {
      電話番号: '0120-352-413',
    },
    ALSOKの事業所案内: 'ALSOKの事業所案内',
    フリーダイヤル: {
      見出し: 'フリーダイヤル',
      電話番号: '0120-39-2413',
    },
    注釈表示領域: {
      // 受注事務所:
      //   "電話アプリにて受注事業所へ電話を掛けます。\n※事業所の営業時間外はつながらない場合がございます。予めホームページ等をご確認ください。\n※電話のプランによって通話料金が発生する場合があります。\n※IP 電話アプリや、別の電話機から電話発信する場合は、上記電話番号に直接ご連絡ください。",
      受注事務所:
        '電話アプリにてALSOKへ電話を掛けます。\n問い合わせ内容により連絡先が異なりますので、画面の案内よりご確認ください。',
      事業所の営業時間外:
        '※事業所の営業時間外はつながらない場合がございます。予めホームページ等をご確認ください。',
      電話のプランによって: '※電話のプランによって通話料金が発生する場合があります。',
      IP電話アプリや:
        '※IP 電話アプリや、別の電話機から電話発信する場合は、上記電話番号に直接ご連絡ください。',
      // 事業所:
      //   "事業所へ電話の際は、画面表示のお客様番号を申し伝えください。\n※事業所の営業時間外はつながらない場合がございます。予めホームページ等をご確認ください。\n※電話のプランによって通話料金が発生する場合があります。",
      事業所:
        'お客様番号が画面に表示されている場合は、お問い合わせの際にお客様番号をお伝えください。\nまた、地区名をお伝えいただく場合は、地区正式名称をお伝えください。',
    },
    戻るボタン: '戻る',
    // 翻訳対象抽出にはなかったが追加
    担当ガードセンター: '担当ガードセンター：{0}',
    メイン地区: 'メイン地区',
  },
  // FE-CU19_対象地区設定画面 path: "/displayDistrictSettings",pages/homeSecurity/displayAreaSetting/Index.vue
  FECU19対象地区設定画面: {
    対象地区設定: '対象地区設定',
    対象地区詳細表示領域: {
      対象地区: '対象地区 - {0}', //対象地区 - 〇〇
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    ニックネーム設定: 'ニックネーム設定',
    対象地区のニックネームの変更: '対象地区のニックネームの変更',
    IDカードキー情報設定: 'IDカード/キー情報設定',
    IDカード操作で表示されるユーザーの情報登録: 'IDカード/キーのニックネーム、有効/無効の設定',
    通知配信設定: '通知配信設定',
    通知送信のONOFF: '通知送信のON/OFF',
    見守り情報配信設定: '見守り情報配信設定',
    見守り情報の配信設定: '見守り情報の配信設定',
    戻るボタン: '戻る',
    //追加
    対象地区: '対象地区',
    メイン地区: 'メイン地区',
  },
  // FE-CU20_ニックネーム設定画面 path: "/setDisplayDistrictNickname",pages/homeSecurity/displayAreaSetting/nickname/Index.vue
  FECU20ニックネーム設定画面: {
    ニックネーム設定: 'ニックネーム設定（対象地区）',
    対象地区詳細表示領域: {
      対象地区: '対象地区 - {0}', //対象地区 - 〇〇
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      // 追加
      地区名: '地区正式名称',
    },
    ニックネーム: 'ニックネーム',
    設定ボタン: '設定',
    戻るボタン: '戻る',
    エラーメッセージ表示領域: '登録に失敗しました。\nもう一度登録してください。',
    OKボタン: 'OK',
    // 追加分
    お知らせ: 'お知らせ',
    閉じる: '閉じる',
    完了: '完了',
    対象地区: '対象地区',
    メイン地区: 'メイン地区',
  },
  // FE-CU21_IDカード/キー情報設定画面 path: "/idCardKeySettings",pages/homeSecurity/displayAreaSetting/IdCardKeyInfo.vue
  FECU21IDカードキー情報設定画面: {
    IDカードキー情報設定: 'IDカード/キー情報設定',
    対象地区詳細領域: {
      対象地区: '対象地区 - {0}', //"対象地区 - ●● （対象地区名）が後ろに入る
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    カードキー情報: 'カード/キー情報',
    ニックネーム: 'ニックネーム',
    有効: '有効',
    無効: '無効',
    設定ボタン: '設定',
    //PCの場合のみ表示部
    有効無効: '有効/無効',
    戻るボタン: '戻る',
    //追加
    対象地区: '対象地区',
    メイン地区: 'メイン地区',
    設定が完了しました: '設定が完了しました。',
  },
  // FE-CU22_通知配信設定画面 path: "/displayDistrictNotificationDeliverySettings",pages/homeSecurity/displayAreaSetting/NotificationSettingDisplayArea.vue
  FECU22通知配信設定画面: {
    通知配信設定: '通知配信設定',
    対象地区詳細領域: {
      対象地区: '対象地区 - {0}',
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    PUSH通知: 'PUSH通知',
    通知するPUSH通知: '通知する',
    通知しないPUSH通知: '通知しない',
    Eメール通知: 'Eメール通知',
    通知するEメール通知: '通知する',
    通知しないEメール通知: '通知しない',
    すべて選択ボタン_PUSH通知: '全て選択',
    クリアボタン_PUSH通知: 'クリア',
    警備操作: '警備操作',
    侵入: '侵入',
    火災: '火災',
    火災復旧: '火災-復旧',
    ガス: 'ガス',
    ガス復旧: 'ガス-復旧',
    非常緊急: '非常/救急',
    非常緊急復旧: '非常/救急-復旧',
    ライフリズム: 'ライフリズム',
    お知らせ: 'お知らせ',
    全て選択ボタンEメール通知: '全て選択',
    クリアボタンEメール通知: 'クリア',
    設定ボタン: '設定',
    戻るボタン: '戻る',
    //スマホの場合 通知配信設定チェックボックス表示領域
    //PCの場合 通知配信設定チェックボックス表示領域
    //表示部
    ライフリズム復旧: 'ライフリズム-復旧',
    設備: '設備',
    設備復旧: '設備-復旧',
    電池切れ: '電池切れ',
    電池切れ復旧: '電池切れ-復旧',
    機器異常: '機器異常 (セルフのみ通知)',
    機器異常復旧: '機器異常-復旧 (セルフのみ通知)',
    //追加分
    通知内容選択: '通知内容選択',
    設定が完了しました: '設定が完了しました。',
    登録に失敗しました: '登録に失敗しました。もう一度設定してください。',
    対象地区: '対象地区',
    メイン地区: 'メイン地区',
  },
  // FE-CU23_見守り情報配信設定画面 path: "/watchOverInfoDeliverySettings",pages/homeSecurity/displayAreaSetting/WatcherInfo.vue
  FECU23見守り情報配信設定画面: {
    見守り情報配信設定: '見守り情報配信設定',
    対象地区詳細領域: {
      対象地区: '対象地区', //「対象地区 - ●●」（対象地区名）が後ろに入る
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    見守り情報配信: '見守り情報配信',
    使用する: '使用する',
    使用しない: '使用しない',
    定期連絡: '定期連絡',
    異常通知: '異常通知',
    定刻連絡: '定刻連絡',
    見守り設定時間: '定刻連絡時間（60〜900分）',
    見守り設定時間異常通知時間: '異常通知時間（60〜900分）',
    分: '分',
    定刻連絡時刻: '定刻連絡時刻',
    時刻1: '①',
    時刻2: '②',
    時刻3: '③',
    操作忘れ監視タイマ: '操作忘れ監視タイマ（1〜99時間）',
    監視する: '監視する',
    時間: '時間',
    配信許可設定: '配信許可設定',
    配信時間を指定: '配信時間を指定',
    波マーク: '{0}:{1}〜{2}:{3}', //HH:MM〜HH:mm
    設定ボタン: '設定',
    戻るボタン: '戻る',
    警備ユニットの取得に失敗しました:
      '警備ユニットとの通信に失敗しました。\n画面を更新してください。',
    //追加
    対象地区: '対象地区',
    通知する: '通知する',
    通知しない: '通知しない',
    見守り方法: '見守り方法',
    設定時間: '時間（5〜900分）',
    メイン地区: 'メイン地区',
  },
  // FE-CU24_機器制御画面 path: "/equipmentControl",pages/machineControl/Index.vue
  FECU24機器制御画面: {
    機器制御: '機器制御',
    対象地区詳細領域: {
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    No: 'No',
    装置名称: '装置名称',
    設定ボタン: '設定',
    戻るボタン: '戻る',
    //追加分
    登録が完了しました: '登録が完了しました。',
    メイン地区: 'メイン地区',
    対象地区: '対象地区',
  },
  // FE-CU25_カメラ画面 path: "/camera",pages/camera/Camera.vue
  FECU25カメラ画面: {
    カメラ: 'カメラ',
    カメラ一覧ボタン: 'カメラ一覧',
    通知履歴ボタン: '通知履歴\n（24時間以内）',
    権限メインユーザー: 'メインユーザー',
    権限サブユーザー: 'サブユーザー',
    加入サービス: '加入サービス',
    最終更新日時: '最新更新日時',
    最新更新日時データ: 'yyyy/M/d H:mm:ss',
    //日付の部分 FE-CU8共通
    日付: '{0}/{1}（{2}）', //{0}=M,{1}=d,{2}=曜日[月,火,水,木,金,土,日]
    HOMEALSOK: 'HOME ALSOK',
    時間: '{0}:{1}', //H:mm
    権限: '権限',
    //追加
    カメラメニュー: 'カメラメニュー',
    戻るボタン: '戻る',
  },
  // FE-CU26_カメラ詳細画面 path: "/cameraDetail",pages/camera/CameraDetail.vue"
  FECU26カメラ詳細画面: {
    カメラ: 'カメラ',
    カメラ詳細表示領域: {
      カメラ詳細: 'カメラ - {0}', //「カメラ - ●●」（カメラ詳細）が後ろに入る
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
    },
    カメラ映像: 'カメラ映像',
    かけつけ依頼: '依頼駆けつけ',
    通知履歴: '通知履歴',
    // ALSOKへのお問い合わせ
    ALSOKへの: 'ALSOKへの',
    お問い合わせ: 'お問い合わせ',
    カメラ設定: 'カメラ設定',
    最終更新日時: '最終更新日時',
    最新更新日時データ: '{0}/{1}/{2} {3}:{4}:{5}', //yyyy/M/d H:mm:ss
    //日付の部分 FE-CU8共通
    HOMEALSOK: 'HOME ALSOK',
    時間: '{0}:{1}', //H:mm
    戻るボタン: '戻る',
    //追加
    カメラ詳細: 'カメラ詳細',
    通知履歴ボタン: '通知履歴\n（24時間以内）',
    カメラメニュー: 'カメラメニュー',
    メイン地区: 'メイン地区',
  },
  // FE-CU27_カメラ設定画面 path: "/cameraSettings", pages/camera/CameraSetting.vue"
  FECU27カメラ設定画面: {
    カメラ設定: 'カメラ設定',
    カメラ: 'カメラ',
    カメラ詳細表示領域: {
      カメラ詳細: 'カメラ', //「カメラ - ●●」（カメラ詳細）が後ろに入る
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム地区表示: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    ニックネーム設定: 'ニックネーム設定',
    カメラのニックネームの変更: 'カメラのニックネームの変更',
    通知配信設定: '通知配信設定',
    通知送信のONOFF: '通知送信のON/OFF',
    戻るボタン: '戻る',
    対象地区: '対象地区',
    メイン地区: 'メイン地区',
  },
  // FE-CU28_ニックネーム設定画面（カメラ） path: "/setCameraNickname",pages/camera/cameraSetting/CameraNickname.vue
  FECU28ニックネーム設定画面カメラ: {
    カメラ: 'カメラ',
    ニックネーム設定: 'ニックネーム設定',
    カメラ詳細表示領域: {
      カメラ詳細: 'カメラ - {0}', //「カメラ - ●●」（カメラ詳細）が後ろに入る
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム地区表示: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    ニックネーム: 'ニックネーム',
    ニックネーム入力フォーム: {
      設定ボタン: '設定',
      戻るボタン: '戻る',
    },
    OKボタン: 'OK',
    // 追加
    spTitle: 'ニックネーム設定',
    メイン地区: 'メイン地区',
  },
  // FE-CU29_通知配信設定画面（カメラ） path: "/cameraNotificationDeliverySettings",pages/camera/cameraSetting/CameraNotificationSetting.vue
  FECU29通知配信設定画面カメラ: {
    通知配信設定: '通知配信設定',
    カメラ詳細表示領域: {
      カメラ詳細: 'カメラ',
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム地区表示: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    メイン地区: 'メイン地区',
    PUSH通知: 'PUSH通知',
    通知する: '通知する',
    通知しない: '通知しない',
    すべて選択ボタン: '全て選択',
    クリアボタン: 'クリア',
    動体検知_ローバッテリー: '動体検知・ローバッテリー',
    Eメール通知: 'Eメール通知',
    設定ボタン: '設定',
    戻るボタン: '戻る',
    通知内容選択: '通知内容選択',
  },
  // FE-CU30_ハウスサポート等お問い合わせ画面 path: "/contactUsHouseSupport",pages/houseSupport/Index.vue
  FECU30ハウスサポート等お問い合わせ画面: {
    //タイトル部
    健康相談等: '健康相談等',
    //表示部
    注釈表示領域: {
      // 電話アプリにて相談窓口へ電話を掛けます:
      //   "電話アプリにて相談窓口へ電話を掛けます。画面表示のお客様番号を申し伝えください。\n※電話のプランによって通話料金が発生する場合があります。\n※IP 電話アプリや、別の電話機から電話発信する場合は、下記電話番号に直接ご連絡ください。",
      電話アプリにて相談窓口へ電話を掛けます:
        '各種サービスについて、お問い合わせ先の電話番号やWEBページへのリンクを表示しています。',
      電話のプランによってIP: '※電話のプランによって通話料金が発生する場合があります。',
      電話のプランによってIP注釈:
        '※IP 電話アプリや、別の電話機から電話発信する場合は、表示された電話番号に直接ご連絡ください。',
      // 相談窓口へ電話の際は:
      //   "相談窓口へ電話の際は、画面表示のお客様番号を申し伝えください。\n※電話のプランによって通話料金が発生する場合があります。",
      相談窓口へ電話の際は:
        '各種サービスについて、お問い合わせ先の電話番号やWEBページへのリンクを表示しています。',
      電話のプランによって: '※電話のプランによって通話料金が発生する場合があります。',
    },
    //お問い合わせ表示部
    Webサイト: 'Webサイト',
    戻るボタン: '戻る',
    // 追加分
    相談窓口: '相談窓口',
    受付時間: '【受付時間】',
    ハウスサポート: 'ハウスサポート',
  },
  // FE-CU31_各種設定画面 path: "/variousSettings",pages/variousSettings/Index.vue
  FECU31各種設定画面: {
    //タイトル部
    各種設定: '各種設定',
    アカウント管理_ログイン方法設定: 'アカウント管理、ログイン方法設定',
    //表示部
    アカウント管理_対象地区: 'アカウント管理\n（対象地区）',
    対象地区に紐づくサブユーザーの登録削除: '対象地区に関係するサブユーザーの登録・削除',
    アカウント管理_カメラ: 'アカウント管理\n（カメラ）',
    カメラに紐づくサブユーザーの登録削除: 'カメラに関係するサブユーザーの登録・削除',
    アカウント管理_ユーザー情報: 'アカウント管理\n（ユーザー情報）',
    ユーザー情報の登録削除: 'ユーザー情報の登録・削除',
    ログイン方法設定: 'ログイン方法設定',
    ログイン方法の設定: 'アプリ使用時のログイン方法を設定',
    //PC表示部
    戻るボタン: '戻る',
    // 追加
    対象地区: '対象地区',
    カメラ: 'カメラ',
    ログイン: 'ログイン',
    ユーザー情報: 'ユーザー情報',
  },
  // FE-CU32_アカウント管理（対象地区）画面 path: "/displayDistrictAccountManagement",pages/accountManagement/displayDistrict/Index.vue
  FECU32アカウント管理対象地区画面: {
    アカウント管理_対象地区: 'アカウント管理（対象地区）',
    ユーザー権限データ: {
      メインユーザー: 'メインユーザー',
      サブユーザー: 'サブユーザー',
    },
    ユーザー管理: 'ユーザー管理',
    ユーザー管理変更ボタン: '変更',
    緊急連絡先: '緊急連絡先',
    緊急連絡策変更ボタン: '変更',
    お客様番号: 'お客様番号',
    警備先名: '警備先名',
    地区番号: '地区番号',
    地区名: '地区正式名称',
    戻るボタン: '戻る',
    デバイスID: 'デバイスID',
    メイン地区: 'メイン地区',
  },
  // FE-CU33_アカウント管理（カメラ）画面 path: "/cameraAccountManagement",pages/accountManagement/camera/Index.vue
  FECU33アカウント管理カメラ画面: {
    アカウント管理_カメラ: 'アカウント管理（カメラ）',
    アカウント管理_対象地区: 'アカウント管理（対象地区）',
    お客様番号: 'お客様番号',
    警備先名: '警備先名',
    ユーザー管理: 'ユーザー管理',
    緊急連絡先: '緊急連絡先',
    地区番号: '地区番号',
    ユーザー権限データ: {
      メインユーザー: 'メインユーザー',
      サブユーザー: 'サブユーザー',
    },
    ユーザー管理変更ボタン: '変更',
    緊急連絡策変更ボタン: '変更',
    削除ボタン: '削除',
    戻るボタン: '戻る',
    削除: '削除',
    カメラ_ニックネーム: 'カメラ（ニックネーム）',
    デバイスID: 'デバイスID',
    閉じるボタン: '閉じる',
    地区名: '地区正式名称',
    // 追加
    登録に失敗しました: '登録に失敗しました。\nもう一度設定してください。',
    メイン地区: 'メイン地区',
  },
  // FE-CU34_アカウント管理(ユーザー情報)画面 path: "/userInfoAccountManagement",pages/accountManagement/userInfo/Index.vue
  FECU34アカウント管理ユーザー情報画面: {
    アカウント管理ユーザー情報: 'アカウント管理（ユーザー情報）',
    氏名: '氏名',
    // 性別任意: "性別（任意）",
    性別: '性別',
    // 生年任意: "生年（任意）",
    生年: '生年',
    任意: '（任意）',
    生年データ: '{0}年', //yyyy年
    ユーザーIDメールアドレス: 'ユーザーID（メールアドレス）',
    パスワード: 'パスワード',
    秘密の質問: '秘密の質問',
    戻るボタン: '戻る',
    アカウント削除ボタン: 'アカウント削除',
    //追加
    未指定: '未指定',
    男性: '男性',
    女性: '女性',
    年: '年',
    変更: '変更',
    ユーザーID: 'ユーザーID',
    メールアドレス: '（メールアドレス）',
  },
  // FE-CU35_ログイン方法設定画面 path: "/loginSettings",pages/loginSettings/Index.vue
  FECU35ログイン方法設定画面: {
    ログイン方法設定: 'ログイン方法設定',
    ユーザーIDパスワードを毎回入力する: 'ユーザーID、パスワードを毎回入力する',
    アプリを使用する際ユーザーIDとパスワードを入力のうえログインする必要があります:
      'アプリを使用する際、ユーザーID とパスワードを入力のうえ、ログインする必要があります。',
    ユーザーIDは省略しパスワードを入力する: 'ユーザーIDは省略し、パスワードを入力する',
    次回ログイン時からパスワードの入力だけでログインできます:
      '次回ログイン時からパスワードの入力だけでログインできます。\nユーザーID の入力欄は、ユーザーID が入力された状態になります。',
    パスコードスマートフォンの生体認証を使う:
      'パスコードまたはスマートフォン・タブレットの生体認証を使う',
    ユーザーIDパスワードの替わりに数字4桁のパスコードだけでログインできます:
      '4桁のパスコードもしくはスマートフォン・タブレットに搭載の生体認証でログインができます。\n生体認証を利用する場合は、パスコードを設定後「生体認証を設定」を選択してください。',
    設定ボタン: '設定',
    設定された内容で登録します: '設定された内容で登録します。\nよろしいでしょうか。',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    設定が完了しました: '設定が完了しました。',
    閉じるボタン: '閉じる',
    //追加
    確認: '確認',
    お知らせ: 'お知らせ',
    ヘルプ:
      'ログイン方法はご利用のスマートフォンごとに設定が必要です。ログイン方法は、メニューボタン⇒設定⇒ログイン方法設定から、いつでも変更が可能です。',
  },
  // FE-CU36_パスコード設定画面 path: "/passcodeSettings",pages/passcodeSettings/Index.vue
  FECU36パスコード設定画面: {
    パスコード4桁を入力してください: 'パスコード4桁を入力してください',
    もう一度入力してください: 'もう一度入力してください',
    パスコードの設定が完了しました生体情報が登録されていません:
      'パスコードの設定が完了しました。\n生体情報が登録されていません。\n設定を開き、生体認証を設定しますか？',
    生体認証を設定: '生体認証を設定',
    設定を終了: '設定を終了',
    //追加
    パスコード設定: 'パスコード設定',
    パスコード設定完了: 'パスコード設定完了',
  },
  // FE-CU37_ユーザー管理画面 path: "/userManagement",pages/userManagement/Index.vue
  FECU37ユーザー管理画面: {
    対象地区詳細表示領域: {
      対象地区: '対象地区', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
    },
    カメラ詳細表示領域: {
      カメラ: 'カメラ', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    ユーザー一覧: 'ユーザー一覧',
    ユーザーIDメールアドレス: 'ユーザーID（メールアドレス）',
    氏名: '氏名',
    ユーザーの権限: 'ユーザーの権限',
    ユーザーの権限データ: {
      メインユーザー: 'メインユーザー',
      サブユーザー: 'サブユーザー',
    },
    変更ボタン: '変更',
    戻るボタン: '戻る',
    サブユーザー追加ボタン: 'サブユーザー追加',
    メインユーザー移譲ボタン: 'メインユーザー移譲',
    //追加
    ユーザー管理: 'ユーザー管理',
    ユーザーID: 'ユーザーID',
    メールアドレス: '（メールアドレス）',
    権限: '権限',
    メイン地区: 'メイン地区',
  },
  // FE-CU38_サブユーザー権限変更画面 path: "/subUserAuthorityChange",pages/subUserAuthorityChange/Index.vue
  FECU38サブユーザー権限変更画面: {
    サブユーザー権限変更: 'サブユーザー権限変更',
    対象地区: '対象地区',
    対象地区詳細表示領域: {
      対象地区: '対象地区', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
    },
    カメラ: 'カメラ',
    カメラ詳細表示領域: {
      カメラ: 'カメラ', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    氏名: '氏名',
    ユーザーIDメールアドレス: 'ユーザーID（メールアドレス）',
    サブユーザーの操作権限: 'サブユーザーの操作権限',
    おすすめボタン: 'おすすめ',
    警備操作: '警備操作',
    かけつけ依頼: '依頼駆けつけ',
    通知通知履歴: '通知/通知履歴',
    機器制御: '機器制御',
    ALSOKへのお問い合わせ: 'ALSOKへのお問い合わせ',
    ニックネーム設定対象地区: 'ニックネーム設定（対象地区）',
    IDカードキー情報設定: 'IDカード/キー情報設定',
    見守り情報配信設定: '見守り情報配信設定',
    戸締り確認: '戸締り確認',
    在宅対象設定: '在宅対象設定',
    ユーザー管理: 'ユーザー管理',
    緊急連絡先: '緊急連絡先',
    対象地区から除外する: '対象地区から除外する',
    カメラから除外する: 'カメラから除外する',
    対象地区から本ユーザーが除外されます: '※対象地区からこのユーザーを除外します。',
    カメラから本ユーザーが除外されます: '※カメラからこのユーザーを除外します。',
    本操作にて:
      '※本操作により、このユーザーが関係する対象地区/カメラが0件となる場合は、ユーザー情報を削除します。',
    本操作にてカメラ:
      '※本操作により、このユーザーが関係する対象地区/カメラが0件となる場合は、ユーザー情報を削除します。',
    カメラ映像: 'カメラ映像',
    ニックネーム設定カメラ: 'ニックネーム設定（カメラ）',
    設定ボタン: '設定',
    設定された内容で登録します: '設定された内容で登録します。',
    よろしいでしょうか: 'よろしいでしょうか。',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    警報確認: '警報確認',
    登録に失敗しました: '登録に失敗しました。',
    もう一度設定してください: 'もう一度設定してください。',
    OKボタン: 'OK',
    //追加
    ユーザーID: 'ユーザーID',
    確認: '確認',
    設定が完了しました: '設定が完了しました。',
    エラー: 'エラー',
    戸締り確認警報確認: '戸締り確認/警報確認',
    戻るボタン: '戻る',
    メイン地区: 'メイン地区',
  },
  // FE-CU39_新規サブユーザー登録画面（仮登録） path: "/subUserTempRegistration",pages/subUserTempRegistration/Index.vue
  FECU39新規サブユーザー登録画面仮登録: {
    対象地区詳細表示領域: {
      対象地区: '対象地区', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
    },
    カメラ詳細表示領域: {
      カメラ: 'カメラ', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    以下のメールアドレスに本登録用のURLを発行する:
      '以下のメールアドレスに本登録用のURLを発行する。',
    メールアドレス: 'メールアドレス',
    確認用: '確認用',
    サブユーザーの操作権限: 'サブユーザーの操作権限',
    おすすめボタン: 'おすすめ',
    警備操作: '警備操作',
    かけつけ依頼: '依頼駆けつけ',
    通知通知履歴: '通知/通知履歴',
    機器制御: '機器制御',
    ALSOKへのお問い合わせ: 'ALSOKへのお問い合わせ',
    ニックネーム設定対象地区: 'ニックネーム設定（対象地区）',
    IDカードキー情報設定: 'IDカード/キー情報設定',
    見守り情報配信設定: '見守り情報配信設定',
    戸締り確認: '戸締り確認',
    在宅対象設定: '在宅対象設定',
    ユーザー管理: 'ユーザー管理',
    緊急連絡先: '緊急連絡先',
    カメラ映像: 'カメラ映像',
    ニックネーム設定カメラ: 'ニックネーム設定（カメラ）',
    仮登録: '仮登録',
    戻るボタン: '戻る',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    OKボタン: 'OK',
    閉じるボタン: '閉じる',
    警報確認: '警報確認',
    //追加
    新規サブユーザー登録仮登録: '新規サブユーザー登録 （仮登録）',
    対象地区から本ユーザーが除外されます: '※対象地区から本ユーザーが除外されます。',
    本操作にて対象地区:
      '※本操作にて対象地区/カメラに紐づかないサブユーザーとなる場合は、サブユーザーが削除されます',
    戸締り確認警報確認: '戸締り確認/警報確認',
    確認: '確認',
    エラー: 'エラー',
    メイン地区: 'メイン地区',
  },
  // FE_CU40 メインユーザー移譲画面 path: "/mainUserTransfer",pages/mainUserTransfer/Index.vue"
  FECU40メインユーザー移譲画面: {
    メインユーザー移譲: 'メインユーザー移譲',
    対象地区詳細表示領域: {
      対象地区: '対象地区', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    カメラ詳細表示領域: {
      カメラ: 'カメラ', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    ユーザーIDメールアドレス: 'ユーザーID（メールアドレス）',
    氏名: '氏名',
    ユーザーの権限: 'ユーザーの権限',
    移譲ボタン: '移譲',
    戻るボタン: '戻る',
    メインユーザー: {
      移譲前: 'メインユーザー（移譲前）',
      移譲後: 'メインユーザー（移譲後）',
      メインユーザー: 'メインユーザー',
    },
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    中止ボタン: '中止',
    続行ボタン: '続行',
    //追加
    ユーザーID: 'ユーザーID',
    サブユーザー: 'サブユーザー',
    メールアドレス: 'メールアドレス',
    確認: '確認',
    アカウント管理_対象地区: 'アカウント管理（対象地区）',
    メイン地区: 'メイン地区',
  },
  // FE_CU41 承認/可否選択画面 path: "/approvalSelect",pages/approvalSelect/Index.vue"
  FECU41承認可否選択画面: {
    承認可否選択: '承認/否認選択',
    メインユーザーによって:
      'メインユーザーによって、以下{0}のメインユーザーがあなたへ移譲されようとしています。\n変更を行ってもよろしいでしょうか。',
    他のユーザによって:
      '他ユーザーによって、以下{0}のサブユーザーにあなたが追加されようとしています。',
    サブユーザーの登録: '以下{0}へのサブユーザーの登録を行ってもよろしいでしょうか。',
    メールアドレスの登録: 'メールアドレスを変更いたしますか。',
    対象地区詳細表示領域: {
      対象地区: '対象地区', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
    },
    カメラ詳細表示領域: {
      カメラ: 'カメラ', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      デバイスID: 'デバイスID',
    },
    メイン地区: 'メイン地区',
    メインユーザー: {
      移譲前: 'メインユーザー（移譲前）',
      移譲後: 'メインユーザー（移譲後）',
    },
    移譲前ユーザーID: 'ユーザーID',
    移譲後ユーザーID: 'ユーザーID',
    移譲前氏名: '氏名',
    否認ボタン: '否認',
    承認ボタン: '承認',
    変更を承認します: '変更を承認します。\nよろしいでしょうか。',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    変更を否認します: '変更を否認します。\nよろしいでしょうか。',
    変更を承認しました: '変更を承認しました。',
    ログイン画面へ: 'ログイン画面へ',
    変更を否認しました: '変更を否認しました。\n変更内容はキャンセルされました。',
    他ユーザーによって以下対象地区のサブユーザーにあなたが追加されようとしています:
      '他ユーザーによって、以下対象地区のサブユーザーにあなたが追加されようとしています。\n以下対象地区へのサブユーザーの登録を行ってもよろしいでしょうか。',
    他ユーザーによって以下カメラのサブユーザーにあなたが追加されようとしています:
      '他ユーザーによって、以下カメラのサブユーザーにあなたが追加されようとしています。　\n以下カメラへのサブユーザーの登録を行ってもよろしいでしょうか。',
    サブユーザーの登録を承認します: 'サブユーザーの登録を承認します。\nよろしいでしょうか。',
    サブユーザーの登録を否認します: 'サブユーザーの登録を否認します。\nよろしいでしょうか。',
    サブユーザーの登録を承認しました: 'サブユーザーの登録を承認しました。',
    サブユーザーの登録を否認しました:
      'サブユーザーの登録を否認しました。\n登録はキャンセルされました。',
    メールアドレスが変更されようとしています: 'メールアドレスを変更いたしますか。',
    メールアドレス: {
      メールアドレス: 'メールアドレス',
      変更前: 'メールアドレス（変更前）',
      変更後: 'メールアドレス（変更後）',
    },
    ユーザー情報の変更を承認します: 'ユーザー情報の変更を承認します。\nよろしいでしょうか。',
    ユーザー情報の変更を否認します: 'ユーザー情報の変更を否認します。\nよろしいでしょうか。',
    ユーザー情報の変更を承認しました: 'ユーザー情報の変更を承認しました。',
    ユーザー情報の変更を否認しました:
      'ユーザー情報の変更を否認しました。\n変更はキャンセルされました。',
    //追加
    対象地区施設名: '警備先名',
    ニックネーム: 'ニックネーム',
    対象地区: '（対象地区）',
    カメラ: '（カメラ）',
    氏名: '氏名',
    警備先名: '警備先名',
  },
  // FE-CU42_緊急連絡先設定画面
  FECU42緊急連絡先設定画面: {
    // タイトル部
    緊急連絡先設定: '緊急連絡先設定',
    // 表示部
    対象地区詳細表示領域: {
      対象地区: '対象地区 - {0}', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム地区表示: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    カメラ詳細表示領域: {
      カメラ: 'カメラ - {0}', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム地区表示: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    メイン地区: 'メイン地区',
    緊急連絡先: '緊急連絡先',
    同居家族情報: '同居家族情報',
    救急情報: '救急情報',
    追加ボタン: '追加',
    並べ替えボタン: '並べ替え',
    氏名: '氏名',
    氏名_プレースホルダー: '80文字まで（例：鈴木太郎）',
    氏名カナ: '氏名（カナ）',
    氏名カナ_プレースホルダー: '80文字まで（例：スズキタロウ）',
    関係: '関係',
    関係_プレースホルダー: '80文字まで（例：本人）',
    電話番号: '電話番号',
    電話番号_プレースホルダー: '半角数字20文字まで（例：050-1234-5678）',
    変更ボタン: '変更',
    削除ボタン: '削除',
    戻るボタン: '戻る',
    キャンセルボタン: 'キャンセル',
    登録ボタン: '登録',
    // ダイアログ部 重複部分は未記載
    上記緊急連絡先を削除します: '上記緊急連絡先を削除します。\nよろしいでしょうか。',
    適用ボタン: '適用',
    第n連絡先: '第{0}連絡先',
    閉じるボタン: '閉じる',
    並び順が適用されました: '並び順が適用されました。',
    並び順が適用されていません: '並び順が適用されていません。\n画面遷移しますか？',
    緊急連絡先情報の取得に失敗しました: '緊急連絡先情報の取得に失敗しました。',
    緊急連絡先情報が登録されていません: '緊急連絡先情報が登録されていません。',
  },
  // FE-CU43_緊急連絡先設定画面-同居家族情報
  FECU43緊急連絡先設定画面同居家族情報: {
    // タイトル部
    緊急連絡先設定: '緊急連絡先設定',
    // 表示部
    対象地区詳細表示領域: {
      対象地区: '対象地区 - {0}', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
    },
    カメラ詳細表示領域: {
      カメラ: 'カメラ - {0}', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
      デバイスID: 'デバイスID',
    },
    メイン地区: 'メイン地区',
    緊急連絡先: '緊急連絡先',
    同居家族情報: '同居家族情報',
    救急情報: '救急情報',
    シークレットコード: 'シークレットコード',
    同居者様本人確認の際にお伺いいたします: '同居者様本人確認の際にお伺いいたします。',
    シークレットコードカナ: 'シークレットコード（カナ）',
    同居家族: '同居家族',
    追加ボタン: '追加',
    並べ替えボタン: '並べ替え',
    氏名: '氏名',
    氏名_プレースホルダー: '20文字まで（例：鈴木太郎）',
    カナ: '氏名（カナ）',
    氏名カナ_プレースホルダー: '40文字まで（例：スズキタロウ）',
    続柄: '続柄',
    生年月日: '生年月日',
    生年月日_プレースホルダー: '年/月/日',
    電話番号: '電話番号',
    変更: '変更',
    削除: '削除',
    戻るボタン: '戻る',
    シークレットコードフリガナ: 'シークレットコード（フリガナ）',
    キャンセルボタン: 'キャンセル',
    登録ボタン: '登録',
    // ダイアログ部 重複部分は未記載
    // 入力された内容で登録します:
    //   "入力された内容で登録します。\nよろしいでしょうか。",
    入力された内容で登録します: '入力された内容で登録します。',
    // 上記同居家族情報を削除します:
    //   "上記同居家族情報を削除します。\nよろしいでしょうか。",
    上記同居家族情報を削除します: '表示の同居家族情報を削除します。',
    よろしいでしょうか: 'よろしいでしょうか。',
    完了: '完了',
    同居家族情報の取得に失敗しました: '同居家族情報の取得に失敗しました。',
    適用ボタン: '適用',
    第1連絡先: '第1連絡先',
    第2連絡先: '第2連絡先',
    第3連絡先: '第3連絡先',
    第4連絡先: '第4連絡先',
    第5連絡先: '第5連絡先',
    登録が完了しました: '登録が完了しました。',
    削除が完了しました: '削除が完了しました。',
    追加が完了しました: '追加が完了しました。',
    変更が完了しました: '変更が完了しました。',
    閉じるボタン: '閉じる',
    並び順が適用されました: '並び順が適用されました。',
    並び順が適用されていません: '並び順が適用されていません。\n画面遷移しますか？',
    緊急連絡先情報の取得に失敗しました: '緊急連絡先情報の取得に失敗しました。',
    緊急連絡先情報が登録されていません: '緊急連絡先情報が登録されていません。',
    //追加
    確認: '確認',
    はいボタン: 'はい',
    いいえボタン: 'いいえ',
  },
  // FE-CU44_緊急連絡先設定画面-救急情報 path: "/emergencyContact",pages/emergencyContact/Index.vue"
  FECU44緊急連絡先設定画面救急情報: {
    対象地区詳細表示領域: {
      対象地区: '対象地区 - {0}', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム地区表示: 'ニックネーム\n（地区表示）',
    },
    カメラ詳細表示領域: {
      カメラ: 'カメラ - {0}', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      デバイスID: 'デバイスID',
    },
    メイン地区: 'メイン地区',
    緊急連絡先: '緊急連絡先',
    同居家族情報: '同居家族情報',
    救急情報: '救急情報',
    追加ボタン: '追加',
    氏名: '氏名',
    カナ: '氏名（カナ）',
    続柄: '続柄',
    生年月日: '生年月日',
    変更: '変更',
    削除: '削除',
    戻るボタン: '戻る',
    // 上記救急情報を削除します:
    //   "上記救急情報を削除します。\nよろしいでしょうか。",
    上記救急情報を削除します: '表示の救急情報を削除します。',
    よろしいでしょうか: 'よろしいでしょうか。',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    救急情報の取得に失敗しました: '救急情報の取得に失敗しました。',
    登録が完了しました: '登録が完了しました。',
    削除が完了しました: '削除が完了しました。',
    閉じるボタン: '閉じる',
    並び順が適用されました: '並び順が適用されました。',
    並び順が適用されていません: '並び順が適用されていません。\n画面遷移しますか？',
    緊急連絡先情報が登録されていません: '緊急連絡先情報が登録されていません。',
    削除に失敗しました: '削除に失敗しました。\nもう一度操作してください。',
    //追加
    確認: '確認',
    完了: '完了',
    関係: '関係',
    電話番号: '電話番号',
    第n連絡先: '第{0}連絡先',
    並べ替え: '並べ替え',
    キャンセルボタン: 'キャンセル',
    登録ボタン: '登録',
    同居家族: '同居家族',
    上記緊急連絡先を削除します: '上記緊急連絡先を削除します。',
  },
  // FE-CU45_救急情報設定画面 path: "/firstAidInfoSettings",pages/firstAidInfo/FirstAidInfo.vue
  FECU45救急情報設定画面: {
    救急情報設定: '救急情報設定',
    対象地区詳細表示領域: {
      対象地区: '対象地区', //対象地区 - ◯◯
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      ニックネーム対象地区: 'ニックネーム\n（対象地区）',
    },
    カメラ詳細表示領域: {
      カメラ: 'カメラ', //カメラ - ●●
      利用プラン: '契約種別',
      お客様番号: 'お客様番号',
      警備先名: '警備先名',
      地区番号: '地区番号',
      地区名: '地区正式名称',
      デバイスID: 'デバイスID',
    },
    メイン地区: 'メイン地区',
    氏名: {
      氏名: '氏名',
      氏名_プレースホルダー: '20文字まで（例：鈴木太郎）',
      カナ: '氏名（カナ）',
      カナ_プレースホルダー: '40文字まで（例：スズキタロウ）',
    },
    性別: '性別',
    性別ラジオボタン: {
      男性: '男性',
      女性: '女性',
    },
    生年月日: '生年月日',
    生年月日_プレースホルダー: '年/月/日',
    既往症病名: '既往症（病名）',
    既往症病名_プレースホルダー: '40文字まで（例：糖尿病1型）',
    かかりつけ医療機関: 'かかりつけ医療機関',
    名称医療機関名: '名称（医療機関名）',
    名称医療機関名_プレースホルダー: '60文字まで（例：〇〇市民病院）',
    住所: '住所',
    住所_プレースホルダー: '120文字まで（例：東京都千代田区1-1 〇〇ビル3F）',
    電話番号: '電話番号',
    電話番号_プレースホルダー: '15文字まで（例：000-0000-0000）',
    担当医師: '担当医師',
    担当医師_プレースホルダー: '20文字まで（例：佐藤先生）',
    設定ボタン: '設定',
    戻るボタン: '戻る',
    入力された内容で登録します: '入力された内容で登録します。\nよろしいでしょうか。',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    設定に失敗しました: '設定に失敗しました。\nもう一度設定してください。',
    OKボタン: 'OK',
    //追加
    設定が完了しました: '設定が完了しました。',
    名称: '名称',
    医療機関名: '（医療機関名）',
  },
  // FE-CU46_サービス追加画面 path: "/serviceAdd",pages/serviceAdd/ServiceAdd.vue
  FECU46サービス追加画面: {
    サービス追加: 'サービス追加',
    本ユーザーが追加したサービスのメインユーザーとして登録されます:
      '本ユーザーが、追加したサービスのメインユーザーとして登録されます。',
    追加したいサービス: '追加したいサービス',
    追加したいサービスセレクト: {
      ホームセキュリティ: 'ホームセキュリティ',
      カメラ: 'カメラ',
      その他サービス: 'その他サービス',
    },
    お客様番号: 'お客様番号',
    認証番号: '認証番号',
    認証番号入力フォーム: '登録',
    デバイスID: 'デバイスID',
    ALSOKから提示されたお客様番号認証番号をお持ちの方は入力してください:
      'ALSOKから提示されたお客様番号/認証番号をお持ちの方は入力してください。',
    登録ボタン: '登録',
    //追加
    製造番号: '製造番号',
    戻るボタン: '戻る',
    半角数字6桁: '半角数字6桁',
    半角数字9桁: '半角数字9桁',
    半角英数字15桁: '半角英数字15桁',
    半角英数字24桁: '半角英数字24桁',
  },
  // FE-CU47_ユーザー情報変更画面（氏名, 電話番号）path: "/changeUserInfoOfPersonalData",pages/user/nameEdit/Index.vue
  FECU47ユーザー情報変更画面氏名電話番号: {
    氏名: '氏名',
    性別任意: '性別 （任意）',
    生年任意: '生年 （任意）',
    戻るボタン: '戻る',
    変更ボタン: '変更',
    //追加分
    ユーザー情報変更: 'ユーザー情報変更',
    未指定: '未指定',
    男性: '男性',
    女性: '女性',
    変更が完了しました: '変更が完了しました。',
  },
  // FE-CU48_ユーザー情報変更画面（メールアドレス）path: "/changeUserInfoOfUserId",/pages/user/mailAddressEdit/Index.vue
  FECU48ユーザー情報変更画面メールアドレス: {
    ユーザー情報変更: 'ユーザー情報変更',
    ユーザーIDメールアドレス: 'ユーザーID\n（メールアドレス）',
    確認用: '確認用',
    変更ボタン: '変更',
    戻るボタン: '戻る',
    いいえボタン確認: 'いいえ',
    はいボタン確認: 'はい',
    現在のパスワード: '現在のパスワード',
  },
  // FE-CU49_ユーザー情報変更画面（パスワード） path: "/changeUserInfoOfPassword",pages/user/passwordEdit/Index.vue
  FECU49ユーザー情報変更画面パスワード: {
    ユーザー情報変更: 'ユーザー情報変更',
    現在のパスワード: '現在のパスワード',
    変更後のパスワード: '変更後のパスワード',
    確認用: '確認用',
    戻るボタン: '戻る',
    変更ボタン: '変更',
    閉じるボタン: '閉じる',
    //追加
    確認: '確認',
    変更が完了しました: '変更が完了しました。',
  },
  // FE-CU50_ユーザー情報変更（秘密の質問）path: "/changeUserInfoOfSecretQuestion",pages/user/secretQuestionEdit/Index.vue
  FECU50ユーザー情報変更秘密の質問: {
    ユーザー情報変更: 'ユーザー情報変更',
    秘密の質問: '秘密の質問',
    回答: '回答 （ひらがな）',
    変更ボタン: '変更',
    戻るボタン: '戻る',
    中止ボタン: '中止',
    続行ボタン: '続行',
    閉じるボタン: '閉じる',
    //追加
    確認: '確認',
    変更が完了しました: '変更が完了しました。',
  },
  // FE-CU51_アカウント削除画面 path: "/accountDelete",pages/user/Delete.vue
  FECU51アカウント削除画面: {
    ユーザー情報変更: 'アカウント削除',
    アカウント削除対象お客様情報: 'アカウント削除対象お客様情報',
    氏名: '氏名',
    ユーザーIDメールアドレス: 'ユーザーID （メールアドレス）',
    削除の注釈表示領域:
      '本アカウントは、ホームセキュリティまたはカメラのメインユーザーであるため、サブユーザーの管理、緊急連絡先設定、ID カード/キーの設定が出来なくなります。',
    メインユーザーの権限をサブユーザーに移譲することも出来ます:
      'メインユーザーの権限をサブユーザーに移譲することもできます。\n再度メインユーザーが必要な場合はメインユーザーの登録を改めて実施する必要があります。',
    削除ボタン: '削除',
    上記アカウントが削除されます: '表示のアカウントが削除されます。',
    戻るボタン: '戻る',
    // あなたはホームセキュリティーまたはカメラにてメインユーザーです:
    //   "あなたは、ホームセキュリティまたはカメラにてメインユーザーです。\nアカウントの削除操作を行いますか。",
    あなたはホームセキュリティーまたはカメラにてメインユーザーです:
      'あなたは、ホームセキュリティまたはカメラにてメインユーザーです。',
    アカウントの削除操作を行いますか: 'アカウントの削除操作を行いますか。',
    中止ボタン: '中止',
    継続ボタンメインユーザーの場合: '続行',
    パスワードを入力してください: 'パスワードを入力してください。',
    削除ボタンパスワード入力ダイアログ: '削除',
    閉じるボタン: '閉じる',
    // 追加
    警告: '警告',
  },
  // FE-CU52_新規メインユーザー登録画面（仮登録）path: "/mainUserTempRegistration",pages/user/temporaryRegistration/Index.vue
  FECU52新規メインユーザー登録画面仮登録: {
    新規メインユーザー登録仮登録: '新規メインユーザー登録（仮登録）',
    本ユーザーが追加したサービスのメインユーザーとして登録されます:
      '本ユーザーが、追加したサービスのメインユーザーとして登録されます。',
    追加したいサービス: '追加したいサービス',
    追加したいサービスセレクト: 'ホームセキュリティ カメラ',
    お客様番号: 'お客様番号',
    製造番号: '製造番号',
    認証番号: '認証番号',
    ユーザーIDメールアドレス: 'ユーザーID（メールアドレス）',
    ユーザーID: 'ユーザーID （メールアドレス）',
    確認用: '確認用',
    仮登録ボタンホームセキュリティ: '仮登録',
    デバイスID: 'デバイスID',
    ALSOKから提示されたお客様番号認証番号をお持ちの方は入力してください:
      'ALSOKから提示されたお客様番号/認証番号をお持ちの方は入力してください。',
    仮登録ボタンカメラ: '仮登録',
    戻るボタン: '戻る',
    登録ボタン: '登録',
    //追加
    ホームセキュリティ: 'ホームセキュリティ',
    カメラ: 'カメラ',
    半角英数字24桁: '半角英数字24桁',
    半角数字9桁: '半角数字9桁',
    半角英数字15桁: '半角英数字15桁',
    半角数字6桁: '半角数字6桁',
  },
  // FE-CU53_ユーザー登録画面（本登録）path: "/userRegistration",pages/user/registration/Index.vue
  FECU53ユーザー登録画面本登録: {
    ユーザー登録本登録: 'ユーザー登録（本登録）',
    お客様番号: 'お客様番号',
    警備先名: '警備先名',
    ニックネーム対象地区: 'ニックネーム設定（対象地区）',
    ニックネーム対象地区スマホ: { ニックネーム: 'ニックネーム', 対象地区: '（対象地区）' },
    氏名: '氏名',
    パスワード: 'パスワード',
    確認用: '確認用',
    秘密の質問: '秘密の質問',
    回答ひらがな: '回答（ひらがな）',
    性別任意: '性別（任意）',
    性別セレクト: { 未指定: '未指定', 男性: '男性', 女性: '女性' },
    生年任意: '生年（任意）',
    生年セレクト: { 未指定: '未指定', 生年: '{0}年' }, //yyyy年
    登録ボタン: '登録',
    入力された内容でユーザー登録を行います:
      '入力された内容でユーザー登録を行います。\nよろしいでしょうか。',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',
    //追加
    確認: '確認',
  },
  // FE-CU54_Thanks画面 path: "/thanks",pages/thanks/Index.vue
  FECU54Thanks画面: {
    メッセージ表示領域: {
      メインユーザー仮登録完了: 'メインユーザー仮登録完了', // C0003
      パスワード初期化受付完了: 'パスワード再登録受付完了', // C0004
      メインユーザー移譲受付完了: 'メインユーザー移譲受付完了', // C0005
      アカウント削除完了: 'アカウント削除完了', // C0011
      サブユーザー本登録完了: 'サブユーザー本登録完了', // C0012
      メインユーザー本登録完了: 'メインユーザー本登録完了', // C0013
      パスワード初期化完了: 'パスワード再登録完了',
      サービス追加完了: 'サービス追加完了', // C0023
      ユーザー情報変更メールアドレス受付完了: 'ユーザー情報変更（メールアドレス）受付完了', // C0020
    },
    ご登録いただいているメールアドレスに:
      'ご登録いただいているメールアドレスに「{0}（件名）」メールを送信しました。', //{0}=件名
    // 以下先頭は●分以内
    メッセージ詳細表示領域: {
      本登録: '{0}分以内にメール本文に記載されているURLより、本登録を行ってください。', // C0006
      パスワード設定:
        '{0}分以内にメール本文に記載されているURLより、秘密の質問を入力後、新しいパスワードの設定を行ってください。', // C0009
      承認否認操作:
        '{0}分以内にメール本文に記載されているURLより、承認／否認操作を行ってください。', // C0007
      アカウントを削除しました: 'アカウントを削除しました。\nご利用ありがとうございました。', // C0015
      サブユーザーを本登録しました: 'サブユーザーを本登録しました。', // C0016
      メインユーザーを本登録しました: 'メインユーザーを本登録しました。', // C0017
      パスワードを初期化しました: 'パスワードを再登録しました。', //C0018
      サービスを追加しました: 'サービスを追加しました。', // C0024
    },
    メールが届かない場合は以下の可能性が考えられます:
      'メールが届かない場合は、以下の可能性が考えられます。',
    メールの設定を変更後再度操作を行ってください:
      'メールの設定を変更後、再度操作を行ってください。',
    迷惑メールとして処理されている可能性があります:
      '・迷惑メールとして処理されている可能性があります。', //先頭○迷惑メール
    迷惑メールフォルダやゴミ箱等に: '迷惑メールフォルダやゴミ箱等に「', //「という件名のメール」との間に「●●」が入る
    という件名のメール: '」という件名のメール',
    がないかご確認をお願いいたします: 'がないか、ご確認をお願いいたします。',
    //以下先頭に○が入る
    ドメイン指定を行っている方は:
      '・ドメイン指定を行っている方は「{0}」を受信できる様に設定してください。', //{0}=domain 「を受信できる様に設定してください。」との間に「＠●●」
    ログイン画面へボタン: 'ログイン画面へ',
    一定回数以上パスワードを間違えたためアカウントはロックされました:
      '一定回数以上パスワードを間違えたためアカウントはロックされました。',
    パスワードを再設定していただくことでロックは解除可能です:
      'パスワードを再設定していただくことでロックは解除可能です。',
    ロックを解除するには: 'ロックを解除するには、',
    までご連絡ください: '{0}までご連絡ください。',
    ALSOKの担当事業所までご連絡ください: 'ALSOKの担当事業所までご連絡ください。',
    このワンタイムURLは失効しました: 'このワンタイムURLは失効しました。', // C0022
    サービスを追加しました: 'サービスを追加しました。',
    アプリの起動に失敗しました: 'アプリの起動に失敗しました。',
    もう一度までご連絡くださいを押してください:
      'もう一度「{0}までご連絡ください。」を押してください。',
    閉じるボタン: '閉じる',
    //追加
    秘密の質問の回答を一定回数以上間違えたためアカウントはロックされました:
      '秘密の質問の回答を一定回数以上間違えたためアカウントはロックされました。', // C0019
    エラーになりました: 'エラーになりました。必要なパラメータが不足しています。',
    パスワードリセット: {
      info1: 'ご登録いただいているメールアドレスに「{0}」メールを送信しました。',
      info2:
        '{0}分以内にメール本文に記載されているURLより、秘密の質問を入力後、新しいパスワードの設定を行ってください。',
      info3:
        'メールが届かない場合は、以下の可能性が考えられます。\nメールの設定を変更後、「<」または「戻る」ボタンでログイン画面に移動し、再度ログインを行ってください。',
      info4:
        '迷惑メールとして処理されている可能性があります。\n迷惑メールフォルダやゴミ箱等に「{0}」という件名のメールがないか、ご確認をお願いいたします。',
      info5: 'ドメイン指定を行っている方は「{0}」を受信できる様に設定してください。',
    },
    ログイン画面へ: 'ログイン画面へ',
  },
  // FE-CU55_Sorry画面 path: "/sorry","../pages/sorry/Index.vue
  FECU55Sorry画面: {
    ただいまシステムにつながりづらい状況です: 'ただいまシステムにつながりづらい状況です。',
    ご利用の皆様にはご迷惑をおかけし申し訳ございません:
      'ご利用の皆様にはご迷惑をおかけし、申し訳ございません。',
    お使いのブラウザは未対応のためご利用いただけません:
      'お使いのブラウザは未対応のためご利用いただけません。',
    動作環境は以下の通りです: '動作環境は以下の通りです。',
    JavaScriptが無効です: 'JavaScriptが無効です。',
    当サイトの利用にはJavaScriptの有効化が必要です:
      '当サイトの利用にはJavaScriptの有効化が必要です。',
    GoogleChrome: 'Google Chrome',
    WindowsAndroidMacOSiOS: '（Windows、Android、Mac OS、iOS）',
    MicrosoftEdge: 'Microsoft Edge',
    Windows: '（Windows）',
    SafariMacOSiOS: 'Safari（Mac OS、iOS）',
    指定されたページは存在しません: '指定されたページは存在しません。',
    大変申し訳ございませんがお探しのページは削除されたかファイル名が間違っている可能性があります:
      '大変申し訳ございませんが、お探しのページは削除されたかファイル名が間違っている可能性があります。',
    アドレスを確認してください: 'アドレスを確認してください。',
    ログイン画面へ移動: '15秒後に、ログイン画面へ移動します。自動的に移動しない方は',
    こちら: 'こちら',
    をクリックしてください: 'をクリックしてください。',
  },
  // FC-CU56_利用規約画面 path: "/terms",pages/terms/Index.vue
  FECU56利用規約画面: {
    利用規約: '利用規約',
    戻るボタン: '戻る',
  },
  // FE-CU57_プライバシーポリシー画面 path: "/privacy",pages/privacy/Index.vue
  FECU57プライバシーポリシー画面: {
    プライバシーポリシー: 'プライバシーポリシー',
    戻るボタン: '戻る',
  },
  // FE-CU58_利用規約・プライバシーポリシー同意画面 path: "/approvalTerms",pages/approvalTerms/ApprovalTerms.vue
  FECU58利用規約プライバシーポリシー同意画面: {
    利用規約プライバシーポリシー: '利用規約/プライバシーポリシー',
    最後までお読みになり画面下部の利用規約に同意しますプライバシーポリシーに同意しますにチェックしてください:
      '最後までお読みになり、画面下部の「利用規約に同意します」、「プライバシーポリシーに同意します」にチェックしてください。',
    ご注意: 'ご注意',
    注意本文1: 'ホームセキュリティサービスは、日本国内に居住されるお客様を対象にしたサービスです。',
    注意本文2:
      '本サービスは、お客様の登録情報や画像データを日本国内に保管します。\nお客様が日本国外に居住されている場合、および個人情報等の移転を規制する法令の適用を受ける場合、本サービスをご利用できません。\nまた、「外国為替および外国貿易法」および国連安全保障理事会決議による輸出管理に関する諸規制等の適用を受ける場合、または禁止事項等の本契約約款の取決めに違反する場合についても、本サービスをご利用できません。',
    利用規約を読む: '利用規約を読む',
    利用規約に同意します: '利用規約に同意します',
    プライバシーポリシーを読む: 'プライバシーポリシーを読む',
    プライバシーポリシーに同意します: 'プライバシーポリシーに同意します',
    次へボタン: '次へ',
    戻るボタン: '戻る',
    利用規約: '利用規約',
    利用規約ダイアログー閉じるボタン: '閉じる',
    プライバシーポリシー: 'プライバシーポリシー',
    プライバシーポリシーダイアログー閉じるボタン: '閉じる',
  },
  // FE-CU59_ライセンス path: "/license",pages/license/Index.vue
  ライセンス: {
    ライセンス: 'ライセンス',
    戻るボタン: '戻る',
  },
  // FE-CU61_ショートカットアクション path: "/shortcutAction",pages/shortcutAction/Index.vue
  FECU61ショートカットアクション画面: {
    処理中: '処理中です。しばらくお待ちください。',
    成功: '警備を解除しました。',
    E0001:
      '一括警備操作の対象地区設定がされていないか、警備操作できる警備ユニットが存在しません。\nトップ画面から対象地区の設定を行ってください。\n（エラーコード：FE-CU61-E0001）',
    E0002:
      '通信に失敗しました。しばらく時間をおいて再度実行してください。\n（エラーコード：FE-CU61-E0002）',
    E0003: '処理が失敗しました。\n警備状態をご確認ください。\n（エラーコード：FE-CU61-E0003）',
  },
  //components/modal/agreementDialog.vue
  agreementDialog: {
    確認: '確認',
    いいえボタン: 'いいえ',
    はいボタン: 'はい',

    パスワードを変更します: 'パスワードを変更します。\nよろしいでしょうか。',

    変更を承認します: '変更を承認します。\nよろしいでしょうか。',
    変更を否認しました: '変更を否認しました。変更内容はキャンセルされました。',

    入力された内容で登録します: '入力された内容で登録します。\nよろしいでしょうか。',
    入力された内容で仮登録します: '入力された内容で仮登録します。\nよろしいでしょうか。',
    入力された内容で仮登録を行います: '入力された内容で仮登録を行います。\nよろしいでしょうか。',
    入力された内容で変更します: '入力された内容で変更します。\nよろしいでしょうか。',

    秘密の質問を変更します: '秘密の質問を変更します。\nよろしいでしょうか。',

    設定された内容で登録します: '設定された内容で登録します。\nよろしいでしょうか。',
    設定が完了していません: '設定が完了していません。\n画面を移動しますか。',
    設定された内容は全ての地区表示へ反映されます:
      '設定された内容は全ての対象地区へ反映されます。\n設定された内容で登録します。\nよろしいでしょうか。',

    警備状態を変更します: '警備状態を変更します。\nよろしいでしょうか。',
    ユーザー削除:
      'ユーザーに紐付く対象地区/カメラが0件になります。\n本ユーザーを削除してもよろしいでしょうか。',
  },
  agreementSelectDialog: {
    確認: '確認',
    カメラを設置する地区を選択してください: 'カメラを設置する地区を選択してください。',
    戻る: '戻る',
    登録: '登録',
  },
  messageDialog: {
    お知らせ: 'お知らせ',
    完了: '完了',
    閉じる: '閉じる',
    アプリの起動に失敗しました:
      'アプリの起動に失敗しました。もう一度電話番号ボタンを押してください。',
    設定が完了しました: '設定が完了しました。',
    エラー: 'エラー',
    OK: 'OK',
    ヘルプ: 'ヘルプ',
  },
  loadingDialog: {
    処理中です: '処理中です。しばらくお待ちください。',
    警備セット中: '警備セット中です。しばらくお待ちください。',
    警備解除中: '警備解除中です。しばらくお待ちください。',
  },
  tokenUpdateError: {
    title: 'お知らせ',
    content:
      'ログインの有効期限が過ぎました。\n再度ログインしてください。\n（エラーコード：FE-CU2-E0001）',
  },
  requirePushNotificationPermission: {
    title: 'お知らせ',
    content:
      'スマートフォン・タブレットのPUSH通知設定が無効になっています。\nスマートフォン・タブレットの設定をご確認ください。',
    openSetting: '設定画面を開く',
    keepStable: 'このまま使用する',
  },
  informationDialog: {
    タイトル: 'お知らせ',
    閉じる: '閉じる',
  },
  errorDialog: {
    タイトル: 'お知らせ',
    閉じる: '閉じる',
  },
  copyRight: 'Copyright © 2023 - 綜合警備保障株式会社',
};
